
//////divakar
import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { FaChartLine } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";

import {
  Box,
  Text,
  Icon,
  List,
  ListItem,
  Img,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  useColorModeValue,
  Tooltip,
  ScaleFade,
  Badge,
} from '@chakra-ui/react';
import { MdOutlineStickyNote2, MdPendingActions } from 'react-icons/md';

import { Draggable } from 'react-beautiful-dnd';
import CustomAccordion from './dragNdrop/CustomAccordion';
import NoteCompo from '../blocksCompo/NoteCompo';
import UrlCompo from '../blocksCompo/UrlCompo';
import WehaveChooseCompo from '../blocksCompo/WehaveChooseCompo';
import SwipeMiniGameCompo from '../blocksCompo/SwipeMiniGameCompo';
import DragForNowCompo from '../blocksCompo/DragForNowCompo';
import DialogCompo from '../blocksCompo/DialogCompo';
import InteractionCompo from '../blocksCompo/InteractionCompo';
import { TbHandClick, TbMessages } from 'react-icons/tb';
import { HiLink } from 'react-icons/hi';
import { FaPlay } from "react-icons/fa";
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import pro from 'assets/img/avatars/pro.png';
import { storyEngAudio } from 'utils/game/gameService';
import NDITabs from './dragNdrop/QuestTab';
import ChatButton from './ChatButton';

import {
  updatePreviewData,
  onFocusField,
  onBlurField,
} from '../../../../../store/preview/previewSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit'; // Import Dispatch type from @reduxjs/toolkit
import { RootState } from 'store/reducers';
import { IoCheckmarkDoneCircle } from 'react-icons/io5';
import ReflectionCompo from '../blocksCompo/ReflectionCompo';
import OverviewCompo from '../blocksCompo/OverviewCompo';
import KeyInsightsCompo from '../blocksCompo/KeyInsightsCompo';

import PreAssessmentCompo from '../blocksCompo/PreAssessmentCompo';
import PostAssessmentCompo from '../blocksCompo/PostAssessmentCompo';
import ScenarioCompletionCompo from '../blocksCompo/ScenarioCompletionCompo'
import { FaAward } from 'react-icons/fa6';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";

interface NDIMainProps {
  showReflectionQuestions?:any;
  handleShowComponent?: (componentName: string) => void;
  id?: any;
  formData: any;
  setBlockItems: any;
  serias: any;
  setserias: any;
  setInput?: any;
  input?: any;
  setItems?: any;
  items?: any;
  alphabet?: any;
  setAlphabet?: any;
  interactionBlock?: any;
  setInteractionBlock?: any;
  countalphabet?: any;
  setAlphabetCount?: any;
  count?: any;
  setCount?: any;
  sequence?: any;
  setSequence?: any;
  dummySequence?: any;
  setDummySequence?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  targetSequence?: any;
  handleKeyDown?: any;
  isDeleteSeq?: any;
  setDeleteseq?: any;
  handleGet?: any;
  fetchBlocks: any;
  listQuest?: any;
  questTabState?: any;
  setQuestTabState?: any;
  deleteQuest?: any;
  upNextCount?: any;
  foundLastInput?: any;
  setUpNextCount?: any;
  reviews?: any;
  reviewers?: any;
  validation?: any;
  setValidation?: any;
  ShowReview?: any;
  listBlockItems?: any;
  languages?: any;
  scrollToElementEnabled?: any;
  setScrollToElementEnabled?: any;
  handleMouseEnter: (review: any, index: number) => void;
  setIsDeleteActionDone: any;
  setChatNote: any;
  chatNote: any;
  BlockItems:any;
   setUploadedFiles:React.Dispatch<
  React.SetStateAction<Record<string, File>>
>;
}

const initial = {
  Note: {
    0: { name: '' },
    1: { name: '' },
  },
};

interface MyObject {
  seqs: any;
  option: any;
  secondaryId: any;
}
type ItemType = {
  option: any;
  id: string;
  name: string;
  content: string;
  type: string;
};
interface BlockItem {
  id: string;
  blockId: any; // Adjust the type as needed
}
const NDIMain: React.FC<NDIMainProps> = ({
  showReflectionQuestions,
  id,
  formData,
  setBlockItems,
  serias,
  setserias,
  setInput,
  input,
  setItems,
  items,
  alphabet,
  setAlphabet,
  interactionBlock,
  setInteractionBlock,
  countalphabet,
  setAlphabetCount,
  count,
  setCount,
  sequence,
  setSequence,
  dummySequence,
  setDummySequence,
  showSelectBlock,
  setSelectBlock,
  targetSequence,
  handleKeyDown,
  isDeleteSeq,
  setDeleteseq,
  handleGet,
  fetchBlocks,
  listQuest,
  questTabState,
  setQuestTabState,
  deleteQuest,
  upNextCount,
  foundLastInput,
  setUpNextCount,
  reviews,
  reviewers,
  validation,
  setValidation,
  ShowReview,
  // setReviews,
  listBlockItems,
  languages,
  handleMouseEnter,
  setScrollToElementEnabled,
  scrollToElementEnabled,
  setIsDeleteActionDone,
  setChatNote,
  chatNote,
  setUploadedFiles,
  BlockItems,
 
  
}) => {
  const [showBox, setShowBox] = useState(false),
    [showMiniBox, setShowMiniBox] = useState<any>(),
    [type, setType] = useState<any>(),
    [alert, setAlert] = useState(false),
    [upNext, setUpNext] = useState<any>(),
    [animateBtn, setAnimateBtn] = useState<any>(),
    [number, setNumber] = useState<any>([]),
    [blockNumber, setBlockNumber] = useState<any>(),
    [lastInputName, setLastInputName] = useState<any>();
  const [inputtextValue, setinputtextValue] = useState('');
  const [blockWiseReviewCount, setBlockWiseReviewCount] = useState<{
    [key: string]: { readCount: number; unReadCount: number; Total: number };
  }>({});
  const [focusInputValue, setFocusInputValue] = useState<string>('');
  const [focusedSeqId, setFocusedSeqId] = useState<string>(null);
  const user: any = JSON.parse(localStorage.getItem('user'));
  const previewStoreData = useSelector((state: RootState) => state.preview);
  const dispatch: Dispatch<any> = useDispatch();
  // For Character Options
  const characterOption = [
    { value: 'player', label: 'Player' },
    { value: 'NPC Name', label: 'NPC_Name' },
    { value: 'narrator', label: 'Narrator' },
     { value: 9999, label: 'Mentor' },
  ];
  // For Dialog Options
  const dialogOption: any = [];
  // For VoicePose Options
  const voicePoseOption = [
    { value: 'talking', label: 'Talking' },
    { value: 'sad', label: 'Sad' },
  ];
  const GameId = id;
  console.log(GameId,"gamdidinndi")
  // onClick Function
  const handleNDI = (NDI: any) => {
    const id = `${serias}.${count}`;
    const upNext = `${serias}.${count + 1}`;
    setUpNext(upNext);
    setType(NDI);
    setShowBox(false);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );

    setItems((prevItems: any) => [
      ...prevItems,
      {
        id,
        type: NDI,
        upNext,
        input: maxInputItem?.input ? maxInputItem.input + 1 : 1,
        questNo: serias,
      },
    ]);

    setSequence([...sequence, id]);
    setDummySequence([...dummySequence, id]);
    setUpNextCount([...upNextCount, upNext]);
    setCount(count + 1);
    setInput((prevInput: any) => {
      const noteKey = `Note${count}`;
      const Linkkey = `Link${count}`;
      const KeyInsightskey = `KeyInsights${count}`;
      
            const PreAssessmentkey = `PreAssessment${count}`;
      const PostAssessmentkey = `PostAssessment${count}`;
      const Overviewkey = `Overview${count}`;
      const ScenarioCompletionkey = `ScenarioCompletion${count}`;
   
      const dialogKey = `Dialog${count}`;
      const interactionKey = `Interaction${count}`;
      const ReflectionKey = `Reflection${count}`;
      const WehaveChooseKey = `WehaveChoose${count}`;
      const SwipeMiniGameKey = `SwipeMiniGame${count}`;
      const DragForNowKey = `DragForNow${count}`;
      if (NDI === 'Note') {
        return {
          ...prevInput,
          [noteKey]: {
            ...prevInput[noteKey],
            id: id,
            note: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'Link') {
        return {
          ...prevInput,
          [Linkkey]: {
            ...prevInput[Linkkey],
            id: id,
            Link: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'SwipeMiniGame') {
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...prevInput[SwipeMiniGameKey],
            id: id,
            SwipeMiniGame: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'DragForNow') {
        return {
          ...prevInput,
          [DragForNowKey]: {
            ...prevInput[DragForNowKey],
            id: id,
            DragForNow: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'WehaveChoose') {
        return {
          ...prevInput,
          [WehaveChooseKey]: {
            ...prevInput[WehaveChooseKey],
            id: id,
            WehaveChoose: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'KeyInsights') {
        return {
          ...prevInput,
          [KeyInsightskey]: {
            ...prevInput[KeyInsightskey],
            id: id,
            KeyInsights: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
     
      if (NDI === 'PreAssessment') {
        return {
          ...prevInput,
          [PreAssessmentkey]: {
            ...prevInput[PreAssessmentkey],
            id: id,
            PreAssessment: '',
            validatePrompt: '',
            evaluationPrompt: '',
            uploadedImage: null,
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'PostAssessment') {
        return {
          ...prevInput,
          [PostAssessmentkey]: {
            ...prevInput[PostAssessmentkey],
            id: id,
            PostAssessment: '',
            validatePrompt: '',
            evaluationPrompt: '',
            uploadedImage: null,
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'Overview') {
        return {
          ...prevInput,
          [Overviewkey]: {
            ...prevInput[Overviewkey],
            id: id,
            Overview: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI === 'ScenarioCompletion') {
        return {
          ...prevInput,
          [ScenarioCompletionkey]: {
            ...prevInput[ScenarioCompletionkey],
            id: id,
            ScenarioCompletion: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
     
      if (NDI === 'Reflection') {
        return {
          ...prevInput,
          [ReflectionKey]: {
            ...prevInput[ReflectionKey],
            id: id,
            Reflection: '',
            dtime: null,
            status: 'yes',
          },
        };
      }
      if (NDI == 'Dialog') {
        return {
          ...prevInput,
          [dialogKey]: {
            ...prevInput[dialogKey],
            id: id,
            dialog: '',
            character: formData.gameNonPlayingCharacterId,
            animation: '',
            voice: '',
            dtime: null,
          },
        };
      }
      if (NDI == 'Interaction') {
        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: id,
            interaction: '',
            status: 'yes',
            blockRoll: formData.gameNonPlayingCharacterId,
            responseRoll: formData.gameNonPlayingCharacterId,
            optionsObject: { A: null, B: null, C: null },
            ansObject: { A: null, B: null, C: null },
            feedbackObject: { A: null, B: null, C: null },
            responseObject: { A: null, B: null, C: null },
            optionTitleObject: { A: null, B: null, C: null },
            optionsemotionObject: { A: null, B: null, C: null },
            optionsvoiceObject: { A: null, B: null, C: null },
            scoreObject: { A: null, B: null, C: null },
            navigateObjects: { A: null, B: null, C: null },
          },
        };
      }
    });
    if (NDI === 'Interaction') {
      const currentAlpha = alphabet
        .slice()
        .find((item: any) => item.seqs === id);
      if (id !== currentAlpha?.seqs) {
        let secondaryArray: any = [];
        let makcount = countalphabet;

        for (let i = 0; i < 3; i++) {
          // Insert data into the array
          let inc = makcount + i + 1;
          secondaryArray.push(inc);
        }
        setAlphabetCount(secondaryArray[2]);
        setAlphabet((prev: any) => [
          ...prev,
          { seqs: id, option: 'A', secondaryId: secondaryArray[0] },
          { seqs: id, option: 'B', secondaryId: secondaryArray[1] },
          { seqs: id, option: 'C', secondaryId: secondaryArray[2] },
        ]);
      }
    }
  };


 const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);

 

  const handleMiniNDI = (seq?: any, i?: any, name?: any) => {
    const sequencial = `${count / 10 + 1}`;
    const upNextSequencial = `${(count + 1) / 10 + 1}`;
    const floatRegex = /^[-+]?(\d*\.\d+|\.\d+)$/;

    const id = `${serias}.${count}`;
    const upNext = `${serias}.${count + 1}`;
    setUpNext(upNext);
    setCount(count + 1);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    const newArr = {
      id,
      type: name,
      upNext,
      input: maxInputItem?.input ? maxInputItem.input + 1 : 1,
      questNo: serias,
    };
    setItems((prevArray: any) => {
      const nextIndex = i + 1;
      setNumber([...number, newArr.input]);
      return [
        ...prevArray.slice(0, nextIndex),
        newArr,
        ...prevArray
          .slice(nextIndex)
          .map((item: any) => ({ ...item, upNext: id })),
      ];
    });

    setSequence([...sequence, id]);
    setDummySequence([...dummySequence, id]);
    setUpNextCount([...upNextCount, upNext]);
    if (name === 'Interaction') {
      const currentAlpha = alphabet
        .slice()
        //  .reverse() // Reverse the array to start searching from the end
        .find((item: any) => item.seqs === id);
      if (id !== currentAlpha?.seqs) {
        let secondaryArray: any = [];
        let makcount = countalphabet;

        for (let i = 0; i < 3; i++) {
          // Insert data into the array
          let inc = makcount + i + 1;
          secondaryArray.push(inc);
        }
        setAlphabetCount(secondaryArray[2]);
        setAlphabet((prev: any) => [
          ...prev,
          { seqs: id, option: 'A', secondaryId: secondaryArray[0] },
          { seqs: id, option: 'B', secondaryId: secondaryArray[1] },
          { seqs: id, option: 'C', secondaryId: secondaryArray[2] },
        ]);
      }
    }
    setInput((prevInput: any) => {
      const noteKey = `Note${count}`;
      const LinkKey = `Link${count}`;
      const SwipeMiniGameKey = `SwipeMiniGame${count}`;
      const DragForNowKey = `DragForNow${count}`;
      const WehaveChooseKey = `WehaveChoose${count}`;
      const KeyInsightsKey = `KeyInsights${count}`;
     
      const PreAssessmentKey = `PreAssessment${count}`;
      const PostAssessmentKey = `PostAssessment${count}`;
      const OverviewKey = `Overview${count}`;
      const ScenarioCompletionKey = `ScenarioCompletion${count}`;

      const ReflectionKey = `Reflection${count}`;
      const dialogKey = `Dialog${count}`;
      const interactionKey = `Interaction${count}`;

      if (name == 'Note') {
        return {
          ...prevInput,
          [noteKey]: {
            ...prevInput[noteKey],
            id: id,
            note: '',
            dtime: null,
          },
        };
      }
      if (name == 'Link') {
        return {
          ...prevInput,
          [LinkKey]: {
            ...prevInput[LinkKey],
            id: id,
            Link: '',
            dtime: null,
          },
        };
      }
      if (name == 'SwipeMiniGame') {
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...prevInput[SwipeMiniGameKey],
            id: id,
            SwipeMiniGame: '',
            dtime: null,
          },
        };
      }
      if (name == 'DragForNow') {
        return {
          ...prevInput,
          [DragForNowKey]: {
            ...prevInput[DragForNowKey],
            id: id,
            DragForNow: '',
            dtime: null,
          },
        };
      }
      if (name == 'WehaveChoose') {
        return {
          ...prevInput,
          [WehaveChooseKey]: {
            ...prevInput[WehaveChooseKey],
            id: id,
            WehaveChoose: '',
            dtime: null,
          },
        };
      }
      if (name == 'KeyInsights') {
        return {
          ...prevInput,
          [KeyInsightsKey]: {
            ...prevInput[KeyInsightsKey],
            id: id,
            KeyInsights: '',
            dtime: null,
          },
        };
      }
      
      if (name == 'PreAssessment') {
        return {
          ...prevInput,
          [PreAssessmentKey]: {
            ...prevInput[PreAssessmentKey],
            id: id,
            PreAssessment: '',
            validatePrompt: '',
            evaluationPrompt: '',
            uploadedImage: null,
            dtime: null,
          },
        };
      }
      if (name == 'PostAssessment') {
        return {
          ...prevInput,
          [PostAssessmentKey]: {
            ...prevInput[PostAssessmentKey],
            id: id,
            PostAssessment: '',
            validatePrompt: '',
            evaluationPrompt: '',
            uploadedImage: null,
            dtime: null,
          },
        };
      }
      if (name == 'Overview') {
        return {
          ...prevInput,
          [OverviewKey]: {
            ...prevInput[OverviewKey],
            id: id,
            Overview: '',
            dtime: null,
          },
        };
      }
      if (name == 'ScenarioCompletion') {
        return {
          ...prevInput,
          [ScenarioCompletionKey]: {
            ...prevInput[ScenarioCompletionKey],
            id: id,
            ScenarioCompletion: '',
            dtime: null,
          },
        };
      }
     
      if (name == 'Reflection') {
        return {
          ...prevInput,
          [ReflectionKey]: {
            ...prevInput[ReflectionKey],
            id: id,
            Reflection: '',
            dtime: null,
          },
        };
      }
      if (name == 'Dialog') {
        return {
          ...prevInput,
          [dialogKey]: {
            ...prevInput[dialogKey],
            id: id,
            dialog: '',
            character: formData.gameNonPlayingCharacterId,
            animation: '',
            voice: '',
            dtime: null,
          },
        };
      }

      if (name == 'Interaction') {
        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: id,
            interaction: '',
            blockRoll: formData.gameNonPlayingCharacterId,
            responseRoll: formData.gameNonPlayingCharacterId,
            optionsObject: { A: null, B: null, C: null },
            ansObject: { A: null, B: null, C: null },
            feedbackObject: { A: null, B: null, C: null },
            responseObject: { A: null, B: null, C: null },
            optionTitleObject: { A: null, B: null, C: null },
            optionsemotionObject: { A: null, B: null, C: null },
            optionsvoiceObject: { A: null, B: null, C: null },
            scoreObject: { A: null, B: null, C: null },
            navigateObjects: { A: null, B: null, C: null },
          },
        };
      }
    });

    setShowMiniBox(false);
  };

  const getSeq = (seq: any, i: any, name: any) => {
    setShowMiniBox((prev: any) => (seq.id == prev ? null : seq.id));
  };

  const duplicateSeq = (seq: any, i: any, name: any, dupdata: any) => {
    const newCount = count + 1;
    const sequencial = `${count / 10 + 1}`;
    const upNextSequencial = `${(count + 1) / 10 + 1}`;
    const id = `${serias}.${count}`;
    const upNext = `${serias}.${newCount}`;
    setUpNext(upNext);
    setCount(newCount);

    // Get the max input index
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );

    const newInput = maxInputItem?.input ? maxInputItem.input + 1 : 1;

    const newArr = {
      id,
      type: name,
      upNext,
      input: newInput,
      questNo: parseInt(serias),
    };

    // ✅ First update the number state
    setNumber((prevNumber: any) => [...prevNumber, newInput]);

    // ✅ Then safely update the items array
    setItems((prevArray: any) => {
      const nextIndex = i + 1;

      return [
        ...prevArray.slice(0, nextIndex),
        newArr,
        ...prevArray.slice(nextIndex).map((item: any) => ({
          ...item,
          upNext: id,
        })),
      ];
    });

    setSequence([...sequence, id]);
    setDummySequence([...dummySequence, id]);
    setUpNextCount([...upNextCount, upNext]);

    // ## Handle Interaction-specific alphabets
    if (name === 'Interaction') {
      const currentAlpha = alphabet.filter((item: any) => item.seqs === seq.id);
      let lastData = alphabet[alphabet.length - 1].secondaryId + 1;

      const duplicateAlpha = currentAlpha.map((item: ItemType) => {
        return { seqs: id, option: item.option, secondaryId: lastData++ };
      });

      setAlphabet((prev: any) => [...prev, ...duplicateAlpha]);
    }

    // ## Set input block data based on type
    setInput((prevInput: any) => {
      const noteKey = `Note${newInput}`;
      const dialogKey = `Dialog${newInput}`;
      const interactionKey = `Interaction${newInput}`;
      const LinkKey = `Link${newInput}`;
      const SwipeMiniGameKey = `SwipeMiniGame${newInput}`;
      const DragForNowKey = `DragForNow${newInput}`;
      const WehaveChooseKey = `WehaveChoose${newInput}`;
      const KeyInsightsKey = `KeyInsights${newInput}`;
     
      const PreAssessmentKey = `PreAssessment${newInput}`;
      const PostAssessmentKey = `PostAssessment${newInput}`;
      const OverviewKey = `Overview${newInput}`;
      const ScenarioCompletionKey = `ScenarioCompletion${newInput}`;
  
      const ReflectionKey = `Reflection${newInput}`;

      const oldNoteKey = prevInput?.[`Note${seq.input}`];
      const oldDialogKey = prevInput?.[`Dialog${seq.input}`];
      const oldInteractionKey = prevInput?.[`Interaction${seq.input}`];
      const oldLinkKey = prevInput?.[`Link${seq.input}`];
      const oldSwipeMiniGameKey = prevInput?.[`SwipeMiniGame${seq.input}`];
      const oldDragForNowKey = prevInput?.[`DragForNow${seq.input}`];
      const oldWehaveChooseKey = prevInput?.[`WehaveChoose${seq.input}`];
      const oldKeyInsightsKey = prevInput?.[`KeyInsights${seq.input}`]; 

      const oldPreAssessmentKey = prevInput?.[`PreAssessment${seq.input}`];
      const oldPostAssessmentKey = prevInput?.[`PostAssessment${seq.input}`];
      const oldOverviewKey = prevInput?.[`Overview${seq.input}`]; 
      const oldScenarioCompletionKey = prevInput?.[`ScenarioCompletion${seq.input}`]; 
    
      const oldReflectionKey = prevInput?.[`Reflection${seq.input}`];

      // ## Add keys to InteractionBlock if applicable
      if (oldInteractionKey?.responseObject?.A) {
        setInteractionBlock((prev: any) => ({
          ...prev,
          [`Resp${newInput}`]: newInput,
        }));
      }
      if (oldInteractionKey?.feedbackObject?.A) {
        setInteractionBlock((prev: any) => ({
          ...prev,
          [`Feedbk${newInput}`]: newInput,
        }));
      }
      if (oldInteractionKey?.SkillTag) {
        setInteractionBlock((prev: any) => ({
          ...prev,
          [`Skills${newInput}`]: newInput,
        }));
      }
      if (oldInteractionKey?.PriorityTag) {
        setInteractionBlock((prev: any) => ({
          ...prev,
          [`Priority${newInput}`]: newInput,
        }));
      }
      if (oldInteractionKey?.optionTitleObject?.A) {
        setInteractionBlock((prev: any) => ({
          ...prev,
          [`Title${newInput}`]: newInput,
        }));
      }

      if (seq.type === 'Note') {
        return {
          ...prevInput,
          [noteKey]: {
            ...oldNoteKey,
            id: id,
            input: newInput,
            note: dupdata?.note,
            Notenavigate: dupdata?.Notenavigate,
            NoteleadShow: dupdata?.NoteleadShow,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'Link') {
        return {
          ...prevInput,
          [LinkKey]: {
            ...oldLinkKey,
            id: id,
            input: newInput,
            Link: dupdata?.Link,
            Linknavigate: dupdata?.Linknavigate,
            LinkleadShow: dupdata?.LinkleadShow,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'SwipeMiniGame') {
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...oldSwipeMiniGameKey,
            id: id,
            input: newInput,
            SwipeMiniGame: dupdata?.SwipeMiniGame,
            SwipeMiniGamenavigate: dupdata?.SwipeMiniGamenavigate,
            SwipeMiniGameleadShow: dupdata?.SwipeMiniGameleadShow,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'DragForNow') {
        return {
          ...prevInput,
          [DragForNowKey]: {
            ...oldDragForNowKey,
            id: id,
            input: newInput,
            DragForNow: dupdata?.DragForNow,
            DragForNownavigate: dupdata?.DragForNownavigate,
            DragForNowleadShow: dupdata?.DragForNowleadShow,
            status: dupdata?.status,
          },
        };
      }
      
      if (seq.type === 'WehaveChoose') {
        return {
          ...prevInput,
          [WehaveChooseKey]: {
            ...oldWehaveChooseKey,
            id: id,
            input: newInput,
            WehaveChoose: dupdata?.WehaveChoose,
            WehaveChoosenavigate: dupdata?.WehaveChoosenavigate,
            WehaveChooseleadShow: dupdata?.WehaveChooseleadShow,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'KeyInsights') {
        return {
          ...prevInput,
          [KeyInsightsKey]: {
            ...oldKeyInsightsKey,
            id: id,
            input: newInput,
            KeyInsights: dupdata?.KeyInsights,
            KeyInsightsnavigate: dupdata?.KeyInsightsnavigate,
            KeyInsightsleadShow: dupdata?.KeyInsightsleadShow,
            status: dupdata?.status,
          },
        };
      }
     
      if (seq.type === 'PreAssessment') {
        return {
          ...prevInput,
          [PreAssessmentKey]: {
            ...oldPreAssessmentKey,
            id: id,
            input: newInput,
            PreAssessment: dupdata?.PreAssessment,
            validatePrompt: dupdata?.validatePrompt,
            evaluationPrompt: dupdata?.evaluationPrompt,
            PreAssessmentnavigate: dupdata?.PreAssessmentnavigate,
            PreAssessmentleadShow: dupdata?.PreAssessmentleadShow,
            uploadedImage: dupdata?.uploadedImage,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'PostAssessment') {
        return {
          ...prevInput,
          [PostAssessmentKey]: {
            ...oldPostAssessmentKey,
            id: id,
            input: newInput,
            PostAssessment: dupdata?.PostAssessment,
            validatePrompt: dupdata?.validatePrompt,
            evaluationPrompt: dupdata?.evaluationPrompt,
            PostAssessmentnavigate: dupdata?.PostAssessmentnavigate,
            PostAssessmentleadShow: dupdata?.PostAssessmentleadShow,
            uploadedImage: dupdata?.uploadedImage,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'Overview') {
        return {
          ...prevInput,
          [OverviewKey]: {
            ...oldOverviewKey,
            id: id,
            input: newInput,
            Overview: dupdata?.Overview,
            Overviewnavigate: dupdata?.Overviewnavigate,
          OverviewleadShow: dupdata?.OverviewleadShow,
            status: dupdata?.status,
          },
        };
      }
      if (seq.type === 'ScenarioCompletion') {
        return {
          ...prevInput,
          [ScenarioCompletionKey]: {
            ...oldScenarioCompletionKey,
            id: id,
            input: newInput,
            ScenarioCompletion: dupdata?.ScenarioCompletion,
            ScenarioCompletionnavigate: dupdata?.ScenarioCompletionnavigate,
          ScenarioCompletionleadShow: dupdata?.ScenarioCompletionleadShow,
            status: dupdata?.status,
          },
        };
      }
     
      if (seq.type === 'Reflection') {
        return {
          ...prevInput,
          [ReflectionKey]: {
            ...oldReflectionKey,
            id: id,
            input: newInput,
            Reflection: dupdata?.Reflection,
            Reflectionnavigate: dupdata?.Reflectionnavigate,
            ReflectionleadShow: dupdata?.ReflectionleadShow,
            status: dupdata?.status,
          },
        };
      }

      if (seq.type === 'Dialog') {
        return {
          ...prevInput,
          [dialogKey]: {
            ...oldDialogKey,
            id: id,
            input: newInput,
            dialog: dupdata?.dialog,
            character: dupdata?.character,
            animation: dupdata?.animation,
            voice: '',
          },
        };
      }

      if (seq.type === 'Interaction') {
        return {
          ...prevInput,
          [interactionKey]: {
            ...oldInteractionKey,
            id: id,
            input: newInput,
            interaction: dupdata?.interaction,
            blockRoll: dupdata?.blockRoll,
            QuestionsEmotion: dupdata?.QuestionsEmotion,
            QuestionsVoice: dupdata?.QuestionsVoice,
            SkillTag: dupdata?.SkillTag,
            PriorityTag: dupdata?.PriorityTag,
            quesionTitle: dupdata?.quesionTitle,
            responseRoll: dupdata?.responseRoll,
            optionsObject: dupdata?.optionsObject,
            ansObject: dupdata?.ansObject,
            feedbackObject: dupdata?.feedbackObject,
            responseObject: dupdata?.responseObject,
            responseemotionObject: dupdata?.responseemotionObject,
            optionTitleObject: dupdata?.optionTitleObject,
            optionsemotionObject: dupdata?.optionsemotionObject,
            optionsvoiceObject: dupdata?.optionsvoiceObject,
            scoreObject: dupdata?.scoreObject,
            navigateObjects: dupdata?.navigateObjects,
            navigateshowObjects: dupdata?.navigateshowObjects,
          },
        };
      }

      return prevInput; // fallback
    });
  };

  const delSeq = (seq: any, i: any, name: any) => {
    const filteredNotes = Object.keys(input)
      .filter((noteKey) => input[noteKey].Notenavigate === seq.input)
      .map((noteKey) => {
        input[noteKey].Notenavigate = null;
        input[noteKey].NoteleadShow = null;
        return input[noteKey];
      });

    const filteredLinks = Object.keys(input)
      .filter((LinkKey) => input[LinkKey].Linknavigate === seq.input)
      .map((LinkKey) => {
        input[LinkKey].Linknavigate = null;
        input[LinkKey].LinkleadShow = null;
        return input[LinkKey];
      });
    const filteredWehaveChoose = Object.keys(input)
      .filter((WehaveChooseKey) => input[WehaveChooseKey].WehaveChoosenavigate === seq.input)
      .map((WehaveChooseKey) => {
        input[WehaveChooseKey].WehaveChoosenavigate = null;
        input[WehaveChooseKey].WehaveChooseleadShow = null;
        return input[WehaveChooseKey];
      });
    const filteredSwipeMiniGame = Object.keys(input)
      .filter((SwipeMiniGameKey) => input[SwipeMiniGameKey].SwipeMiniGamenavigate === seq.input)
      .map((SwipeMiniGameKey) => {
        input[SwipeMiniGameKey].SwipeMiniGamenavigate = null;
        input[SwipeMiniGameKey].SwipeMiniGameleadShow = null;
        return input[SwipeMiniGameKey];
      });
    const filteredKeyInsights = Object.keys(input)
      .filter((KeyInsightsKey) => input[KeyInsightsKey].KeyInsightsnavigate === seq.input)
      .map((KeyInsightsKey) => {
        input[KeyInsightsKey].KeyInsightsnavigate = null;
        input[KeyInsightsKey].KeyInsightsleadShow = null;
        return input[KeyInsightsKey];
      });
      const filteredPreAssessment = Object.keys(input)
      .filter((PreAssessmentKey) => input[PreAssessmentKey].PreAssessmentnavigate === seq.input)
      .map((PreAssessmentKey) => {
        input[PreAssessmentKey].PreAssessmentnavigate = null;
        input[PreAssessmentKey].PreAssessmentleadShow = null;
        return input[PreAssessmentKey];
      });
      const filteredPostAssessment = Object.keys(input)
      .filter((PostAssessmentKey) => input[PostAssessmentKey].PostAssessmentnavigate === seq.input)
      .map((PostAssessmentKey) => {
        input[PostAssessmentKey].PostAssessmentnavigate = null;
        input[PostAssessmentKey].PostAssessmentleadShow = null;
        return input[PostAssessmentKey];
      });
    const filteredReflection = Object.keys(input)
      .filter((ReflectionKey) => input[ReflectionKey].Reflectionnavigate === seq.input)
      .map((ReflectionKey) => {
        input[ReflectionKey].Reflectionnavigate = null;
        input[ReflectionKey].ReflectionleadShow = null;
        return input[ReflectionKey];
      });

    const filteredDialog = Object.keys(input)
      .filter((dialogKey) => input[dialogKey].Dialognavigate === seq.input)
      .map((dialogKey) => {
        input[dialogKey].Dialognavigate = null;
        input[dialogKey].DialogleadShow = null;
        return input[dialogKey];
      });
    const filteredInteraction = Object.keys(input)
      .filter(
        (interactionkey) =>
          input[interactionkey].navigateObjects &&
          Object.values(input[interactionkey].navigateObjects).includes(
            seq.input,
          ),
      )
      .map((interactionkey) => {
        Object.keys(input[interactionkey].navigateObjects).forEach((option) => {
          if (input[interactionkey].navigateObjects[option] === seq.input) {
            input[interactionkey].navigateObjects[option] = null;
            input[interactionkey].navigateshowObjects[option] = null;
          }
        });
        return input[interactionkey];
      });

    if (name === 'Interaction') {
      setAlphabet((prevAlphabet: any) => {
        // Use filter to create a new array without items that match the condition
        const updatedAlphabet = prevAlphabet?.filter(
          (item: any) => item.seqs !== seq.id,
        );
        return updatedAlphabet;
      });
    }
    setItems((previtems: any) => {
      // Use filter to create a new array without items that match the condition
      const updatedItems = previtems?.filter(
        (item: any) => item.input !== seq.input,
      );
      return updatedItems;
    });
    setDeleteseq(true);

    dispatch(
      updatePreviewData({
        gameId: parseInt(id),
        action: {
          name: 'blockDelete',
          value: seq.id,
          quest: seq.questNo,
          DelseQ: seq.input,
        },
      }),
    );
    setIsDeleteActionDone((prev: any) => ({ ...prev, reqStatus: true }));
  };

  const handleBottomNDI = (NDI: any) => {
    const sequencial = `${count / 10 + 1}`;
    const upNextSequencial = `${(count + 1) / 10 + 1}`;
    const floatRegex = /^[-+]?(\d*\.\d+|\.\d+)$/;
    const id = `${serias}.${count}`;
    const upNext = `${serias}.${count + 1}`;
    setUpNext(upNext);
    setType(NDI);
    setShowBox(false);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );

    setItems((prevItems: any) => {
      return [
        ...prevItems,
        {
          id: id,
          type: NDI,
          upNext: upNext,
          input: maxInputItem?.input ? maxInputItem.input + 1 : 1,
          questNo: serias,
        },
      ];
    });

    setSequence([...sequence, id]);
    setDummySequence([...dummySequence, id]);
    setUpNextCount([...upNextCount, upNext]);
    setCount(count + 1);

    if (NDI === 'Interaction') {
      const currentAlpha = alphabet
        .slice()
        //  .reverse() // Reverse the array to start searching from the end
        .find((item: any) => item.seqs === id);
      if (id !== currentAlpha?.seqs) {
        let secondaryArray: any = [];
        let makcount = countalphabet;

        for (let i = 0; i < 3; i++) {
          // Insert data into the array
          let inc = makcount + i + 1;
          secondaryArray.push(inc);
        }
        setAlphabetCount(secondaryArray[2]);
        setAlphabet((prev: any) => [
          ...prev,
          { seqs: id, option: 'A', secondaryId: secondaryArray[0] },
          { seqs: id, option: 'B', secondaryId: secondaryArray[1] },
          { seqs: id, option: 'C', secondaryId: secondaryArray[2] },
        ]);
      }
    }
    setInput((prevInput: any) => {
      const noteKey = `Note${count}`;
      const dialogKey = `Dialog${count}`;
      const LinkKey = `Link${count}`;
      const SwipeMiniGameKey = `SwipeMiniGame${count}`;
      const DragForNowKey = `DragForNow${count}`;
      const WehaveChooseKey = `WehaveChoose${count}`;
      const KeyInsightsKey = `KeyInsights${count}`;
  
      const PreAssessmentKey = `PreAssessment${count}`;
      const PostAssessmentKey = `PostAssessment${count}`;
      const OverviewKey = `Overview${count}`;
      const ScenarioCompletionKey = `ScenarioCompletion${count}`;
   
      const interactionKey = `Interaction${count}`;
      const ReflectionKey = `Reflection${count}`;
      if (NDI == 'Note') {
        return {
          ...prevInput,
          [noteKey]: {
            ...prevInput[noteKey],
            id: id,
            note: '',
            dtime: null,
          },
        };
      }
      if (NDI == 'Link') {
        return {
          ...prevInput,
          [LinkKey]: {
            ...prevInput[LinkKey],
            id: id,
            Link: '',
            dtime: null,
          },
        };
      }
      if (NDI == 'SwipeMiniGame') {
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...prevInput[SwipeMiniGameKey],
            id: id,
            SwipeMiniGame: '',
            dtime: null,
          },
        };
      }
      if (NDI == 'DragForNow') {
        return {
          ...prevInput,
          [DragForNowKey]: {
            ...prevInput[DragForNowKey],
            id: id,
            DragForNow: '',
            dtime: null,
          },
        };
      }
      if (NDI == 'WehaveChoose') {
        return {
          ...prevInput,
          [WehaveChooseKey]: {
            ...prevInput[WehaveChooseKey],
            id: id,
            WehaveChoose: '',
            dtime: null,
          },
        };
      }
      
      if (NDI == 'KeyInsights') {
        return {
          ...prevInput,
          [KeyInsightsKey]: {
            ...prevInput[KeyInsightsKey],
            id: id,
            KeyInsights: '',
            dtime: null,
          },
        };
      }
      
      if (NDI == 'PreAssessment') {
        return {
          ...prevInput,
          [PreAssessmentKey]: {
            ...prevInput[PreAssessmentKey],
            id: id,
            PreAssessment: '',
            validatePrompt: '',
            evaluationPrompt: '',
            uploadedImage: null,
            dtime: null,
          },
        };
      }
      if (NDI == 'PostAssessment') {
        return {
          ...prevInput,
          [PostAssessmentKey]: {
            ...prevInput[PostAssessmentKey],
            id: id,
            PostAssessment: '',
            validatePrompt: '',
            evaluationPrompt: '',
            uploadedImage: null,
            dtime: null,
          },
        };
      }
      if (NDI == 'Overview') {
        return {
          ...prevInput,
          [OverviewKey]: {
            ...prevInput[OverviewKey],
            id: id,
            Overview: '',
            dtime: null,
          },
        };
      }
      if (NDI === 'ScenarioCompletion') {
        return {
          ...prevInput,
          [ScenarioCompletionKey]: {
            ...prevInput[ScenarioCompletionKey],
            id: id,
            ScenarioCompletion: '',
            dtime: null,
          },
        };
      }
      
      if (NDI === 'Reflection') {
        return {
          ...prevInput,
          [ReflectionKey]: {
            ...prevInput[ReflectionKey],
            id: id,
            Reflection: '',
            dtime: null,
          },
        };
      }

      if (NDI == 'Dialog') {
        return {
          ...prevInput,
          [dialogKey]: {
            ...prevInput[dialogKey],
            id: id,
            dialog: '',
            character: formData.gameNonPlayingCharacterId,
            animation: '',
            voice: '',
            dtime: null,
          },
        };
      }

      if (NDI == 'Interaction') {
        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: id,
            interaction: '',
            blockRoll: formData.gameNonPlayingCharacterId,
            responseRoll: formData.gameNonPlayingCharacterId,
            quesionTitle: '',
            optionsObject: { A: null, B: null, C: null },
            ansObject: { A: null, B: null, C: null },
            feedbackObject: { A: null, B: null, C: null },
            responseObject: { A: null, B: null, C: null },
            optionTitleObject: { A: null, B: null, C: null },
            optionsemotionObject: { A: null, B: null, C: null },
            optionsvoiceObject: { A: null, B: null, C: null },
            scoreObject: { A: null, B: null, C: null },
            navigateObjects: { A: null, B: null, C: null },
          },
        };
      }
    });
  };

  const handleBlockRoll = (selectedOption: any, i: any, keyvalue: any) => {
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const blockroll = selectedOption.value;

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          blockRoll: blockroll,
        },
      };
    });
  };
  const handleDialogBlockRoll = (
    selectedOption: any,
    i: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      // const interactionKey = `Dialog${items[key]?.input}`;
      const dialogKey = keyvalue;
      const blockroll = selectedOption.value;
      return {
        ...prevInput,
        [dialogKey]: {
          ...prevInput[dialogKey],
          id: items[i]?.id,
          character: blockroll,
        },
      };
    });
  };
  const handleResponseRoll = (selectedOption: any, i: any, keyvalue: any) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const responseRoll = selectedOption.value;

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          responseRoll: responseRoll,
        },
      };
    });
  };
  const handleTagsChange = (tags: any, interaction: any) => {
    const tagNames = tags.map((tag: any) => tag.name);

    // Convert the array of tag names into a string
    const tagsString = tagNames.join(', ');

    setInput((prevInput: any) => {
      const interactionKey = `${interaction}`;
      const SkillTag = tagsString;
      const PriorityTag = tagsString;

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          SkillTag: SkillTag,
          PriorityTag: PriorityTag,
        },
      };
    });
  };
  const handleQuestionEmotion = (
    selectedOption: any,
    i: any,
    keyvalue: any,
  ) => {
    const selectedValues = selectedOption.map((option: any) => option.value);

    const resultString = selectedValues.join(', ');
    const resultArray = resultString.split(', ');
    const arrayLength = resultArray.length;

    setValidation({
      ...validation,
      [`QuestionsEmotion${i}`]: selectedOption === '' ? true : false,
    });

    if (arrayLength <= 2) {
      setInput((prevInput: any) => {
        const interactionKey = keyvalue;
        const QuestionsEmotion = resultString;

        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: items[i]?.id,
            QuestionsEmotion: QuestionsEmotion,
          },
        };
      });
    }
  };

  const handleDialogEmotion = (selectedOption: any, i: any) => {
    const selectedValues = selectedOption.map((option: any) => option.value);

    // Use the array of strings as needed, for example, join them into a single string
    const resultString = selectedValues.join(', ');
    const resultArray = resultString.split(', ');
    const arrayLength = resultArray.length;

    if (arrayLength <= 2) {
      setInput((prevInput: any) => {
        const interactionKey = `Dialog${i}`;
        const DialogEmotion = resultString;
        setValidation({
          ...validation,
          [`dailogAnimation${i}`]: DialogEmotion === '' ? true : false,
        });
        // Lokie 0007

        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: items[i]?.id,
            animation: DialogEmotion,
          },
        };
      });
    }
  };

  const handleDialogVoice = (selectedOption: any, i: any) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = `Dialog${items[key]?.input}`;
      const Dialogvoice = selectedOption.value;

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          voice: Dialogvoice,
        },
      };
    });
  };

  const handleQuestionVoice = (selectedOption: any, i: any, keyvalue: any) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const QuestionsVoice = selectedOption.value;

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          QuestionsVoice: QuestionsVoice,
        },
      };
    });
  };

  const handleOptionEmotion = (
    selectedOption: any,
    i: any,
    optionemotion: any,
    keyvalue: any,
  ) => {
    const key = i - 1;
    const selectedValues = selectedOption.map((option: any) => option.value);

    const resultString = selectedValues.join(', ');
    const resultArray = resultString.split(', ');
    const arrayLength = resultArray.length;
    if (arrayLength <= 2) {
      setInput((prevInput: any) => {
        const interactionKey = keyvalue;
        const OptionEmotion = selectedOption.value;
        const optionsemotionObject: any = {};

        alphabet.forEach((item: any) => {
          const optValue =
            optionemotion === `Option${item.option}`
              ? resultString
              : prevInput[interactionKey]?.optionsemotionObject?.[item.option];
          handleValidation(item, validation, setValidation);
          optionsemotionObject[item.option] = optValue;
        });
        function handleValidation(
          item: any,
          validation: any,
          setValidation: any,
        ) {
          const optionEmotionKey = `optionsEmotion${i}${item?.option}`;
          const isValid =
            optionsemotionObject?.[item?.option] === '' ? true : false;

          setValidation((prevValidation: any) => ({
            ...prevValidation,
            [optionEmotionKey]: isValid,
          }));
          // Lokie 0007
          if (isValid === false) {
            setValidation((prevValidation: any) => ({
              ...prevValidation,
              [`Interaction${i}`]: false,
            }));
          }
        }
        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: items[i]?.id,
            optionsemotionObject: optionsemotionObject,
          },
        };
      });
    }
  };

  const handleOptionVoice = (
    selectedOption: any,
    i: any,
    optionvoice: any,
    keyvalue: any,
  ) => {
    const key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const OptionVoice = selectedOption.value;
      const optionsvoiceObject: any = {};

      alphabet.forEach((item: any) => {
        const optValue =
          optionvoice === `Option${item.option}`
            ? selectedOption.value
            : prevInput[interactionKey]?.optionsvoiceObject?.[item.option];
        optionsvoiceObject[item.option] = optValue;
      });
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          optionsvoiceObject: optionsvoiceObject,
        },
      };
    });
  };

  const handleResponseEmotion = (
    selectedOption: any,
    i: any,
    responseemotion: any,
    keyvalue: any,
  ) => {
    const key = i - 1;
    const selectedValues = selectedOption.map((option: any) => option.value);

    const resultString = selectedValues.join(', ');
    const resultArray = resultString.split(', ');
    const arrayLength = resultArray.length;
    if (arrayLength <= 2) {
      setInput((prevInput: any) => {
        const interactionKey = keyvalue;
        const OptionEmotion = selectedOption.value;
        const responseemotionObject: any = {};

        alphabet.forEach((item: any) => {
          const optValue =
            responseemotion === `Option${item.option}`
              ? resultString
              : prevInput[interactionKey]?.responseemotionObject?.[item.option];
          responseemotionObject[item.option] = optValue;
        });
        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: items[i]?.id,
            responseemotionObject: responseemotionObject,
          },
        };
      });
    }
  };

  const handleCheckBox = (
    checked: any,
    i: any,
    optionright: any,
    keyvalue: any,
  ) => {
    const isChecked = checked.target.checked;
    const key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const ansObject: any = {};

      alphabet.forEach((item: any) => {
        const optValue =
          optionright === `Option${item.option}`
            ? checked.target.checked
            : prevInput[interactionKey]?.ansObject?.[item.option];
        ansObject[item.option] = optValue;
      });
      const checkAnsObject: any = Object.values(ansObject).filter(
        (item: any) => item === true,
      );
      const checkedIsTrue: any = checkAnsObject.find(
        (item: any) => item === true,
      );
      setValidation({
        ...validation,
        [`checkbox${i}`]: checkedIsTrue === undefined ? true : false,
      });
      // Lokie 0007
      if (checkedIsTrue != undefined) {
        setValidation({
          ...validation,
          [`Interaction${i}`]: false,
          [`checkbox${i}`]: false,
        });
      }

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          ansObject: ansObject,
        },
      };
    });
  };

  const setNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    const key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigateObjects: any = {};
      const navigateshowObjects: any = {};
      alphabet.forEach((item: any) => {
        const optValue =
          foroption === `Option${item.option}`
            ? menuvalue
            : prevInput[interactionKey]?.navigateObjects?.[item.option];

        const optValueS =
          foroption === `Option${item.option}`
            ? menuvalue
            : prevInput[interactionKey]?.navigateshowObjects?.[item.option];
        navigateObjects[item.option] = optValue;
        navigateshowObjects[item.option] = optValueS;

        if (optValueS) {
          setValidation((prevValidation: any) => ({
            ...prevValidation,
            [`Interaction${i}`]: false,
          }));
        }
      });

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          navigateObjects: navigateObjects,
          navigateshowObjects: navigateshowObjects,
        },
      };
    });
  };
  const handleNoteNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;
      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Notenavigate: navigate,
        },
      };
    });
  };

  const handleLinkNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Linknavigate: navigate,
        },
      };
    });
  };
  const handleWehaveChooseNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          WehaveChoosenavigate: navigate,
        },
      };
    });
  };
  const handleKeyInsightsNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          KeyInsightsnavigate: navigate,
        },
      };
    });
  };
  
  
    const handleDragForNowNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          DragForNownavigate: navigate,
        },
      };
    });
  };
  const handleSwipeMiniGameNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          SwipeMiniGamenavigate: navigate,
        },
      };
    });
  };
  const handlePreAssessmentNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          PreAssessmentnavigate: navigate,
        },
      };
    });
  };
  const handlePostAssessmentNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          PostAssessmentnavigate: navigate,
        },
      };
    });
  };
  const handleOverviewNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Overviewnavigate: navigate,
        },
      };
    });
  };
  const handleScenarioCompletionNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          ScenarioCompletionnavigate: navigate,
        },
      };
    });
  };
 
  const handleReflectionNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Reflectionnavigate: navigate,
        },
      };
    });
  };

  const setNoteNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;
      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Notenavigate: navigate,
          NoteleadShow: navigate,
        },
      };
    });
  };

  const setLinkNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Linknavigate: navigate,
          LinkleadShow: navigate,
        },
      };
    });
  };
  const setWehaveChooseNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          WehaveChoosenavigate: navigate,
          WehaveChooseleadShow: navigate,
        },
      };
    });
  };
  const setKeyInsightsNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          KeyInsightsnavigate: navigate,
          KeyInsightsleadShow: navigate,
        },
      };
    });
  };
  const setSwipeMiniGameNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          SwipeMiniGamenavigate: navigate,
         SwipeMiniGameleadShow: navigate,
        },
      };
    });
  };
   const setDragForNowNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          DragForNownavigate: navigate,
          DragForNowleadShow: navigate,
        },
      };
    });
  };
  const setPreAssessmentNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          PreAssessmentnavigate: navigate,
          PreAssessmentleadShow: navigate,
        },
      };
    });
  };
  const setPostAssessmentNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          PostAssessmentnavigate: navigate,
          PostAssessmentleadShow: navigate,
        },
      };
    });
  };
  const setOverviewNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Overviewnavigate: navigate,
          OverviewleadShow: navigate,
        },
      };
    });
  };
  const setScenarioCompletionNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          ScenarioCompletionnavigate: navigate,
          ScenarioCompletionleadShow: navigate,
        },
      };
    });
  };
  
  const setReflectionNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Reflectionnavigate: navigate,
          ReflectionleadShow: navigate,
        },
      };
    });
  };


  const setNotelead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;
      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          NoteleadShow: navigate,
          Notenavigate: null,
        },
      };
    });
  };
  const setLinklead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          LinkleadShow: navigate,
          Linknavigate: null,
        },
      };
    });
  };
  const setWehaveChooselead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          WehaveChooseleadShow: navigate,
          WehaveChoosenavigate: null,
        },
      };
    });
  };
  const setKeyInsightslead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          KeyInsightsleadShow: navigate,
          KeyInsightsnavigate: null,
        },
      };
    });
  };
  const setSwipeMiniGamelead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          SwipeMiniGameleadShow: navigate,
          SwipeMiniGamenavigate: null,
        },
      };
    });
  };
  
   const setDragForNowlead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          DragForNowleadShow: navigate,
          DragForNownavigate: null,
        },
      };
    });
  };

   const setPreAssessmentlead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          PreAssessmentleadShow: navigate,
          PreAssessmentnavigate: null,
        },
      };
    });
  };
  const setPostAssessmentlead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          PostAssessmentleadShow: navigate,
          PostAssessmentnavigate: null,
        },
      };
    });
  };
  const setOverviewlead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
        OverviewleadShow: navigate,
          Overviewnavigate: null,
        },
      };
    });
  };
  const setScenarioCompletionlead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
        ScenarioCompletionleadShow: navigate,
        ScenarioCompletionnavigate: null,
        },
      };
    });
  };

  const setReflectionlead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          ReflectionleadShow: navigate,
          Reflectionnavigate: null,
        },
      };
    });
  };
  const handleDialogNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue.value;
      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Dialognavigate: navigate,
        },
      };
    });
  };

  const setDialogNavigation = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;
      // Lokie 0007
      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          Dialognavigate: navigate,
          DialogleadShow: navigate,
        },
      };
    });
  };
  const setDialoglead = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    let key = i - 1;
    setInput((prevInput: any) => {
      const interactionKey = keyvalue;
      const navigate = menuvalue;

      if (navigate) {
        setValidation((prevValidation: any) => ({
          ...prevValidation,
          [`Navigation${i}`]: false,
        }));
      }

      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          DialogleadShow: navigate,
          Dialognavigate: null,
        },
      };
    });
  };

  const handleBlock = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    const key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;

      const navigateshowObjects: any = {};

      const navigateObjects: any = {};

      alphabet.forEach((item: any) => {
        const optValue =
          foroption === `Option${item.option}`
            ? menuvalue
            : prevInput[interactionKey]?.navigateshowObjects?.[item.option];
        navigateshowObjects[item.option] = optValue;
        const optValue1 =
          foroption === `Option${item.option}`
            ? ''
            : prevInput[interactionKey]?.navigateObjects?.[item.option];
        navigateObjects[item.option] = optValue1;
      });
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          navigateshowObjects: navigateshowObjects,
          navigateObjects: navigateObjects,
        },
      };
    });
  };

  const handleSelectBlock = (
    menuvalue: any,
    i: any,
    foroption: any,
    keyvalue: any,
  ) => {
    const key = i - 1;

    setInput((prevInput: any) => {
      const interactionKey = keyvalue;

      const navigateObjects: any = {};

      alphabet.forEach((item: any) => {
        const optValue =
          foroption === `Option${item.option}`
            ? menuvalue.value
            : prevInput[interactionKey]?.navigateObjects?.[item.option];

        navigateObjects[item.option] = optValue;

        // Lokie 0007
        if (optValue) {
          setValidation((prevValidation: any) => ({
            ...prevValidation,
            [`NavigationOption${i}`]: false,
          }));
        }
      });
      return {
        ...prevInput,
        [interactionKey]: {
          ...prevInput[interactionKey],
          id: items[i]?.id,
          navigateObjects: navigateObjects,
        },
      };
    });
  };

  //handles the content updation for Demoplay
  const blockOnFocusHanlder = async (e: any, seqId: any) => {
    setFocusInputValue(e.target.value);
    setFocusedSeqId(seqId);

    dispatch(onFocusField({ gameId: id, focusValue: e.target.value }));
  };
  const blockOnBlurHanlder = (e: any, seqId: any) => {
    dispatch(onBlurField({ gameId: id, blurValue: e.target.value }));
  };
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (
        document.hidden &&
        focusInputValue &&
        focusedSeqId &&
        inputtextValue
      ) {
        blockOnBlurHanlder({ target: { value: inputtextValue } }, focusedSeqId);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);



  const handleInput = async (e: any, i?: any, BlockNum?: any) => {
    // const textarea = e.target;
    // textarea.style.height = 'auto';
    // textarea.style.height = `${textarea.scrollHeight}px`;
    // setinputtextValue(textarea.value);
    const textarea = e?.target;

// ✅ Only run for real DOM inputs (Textarea / Input)
if (textarea && textarea.style && textarea.scrollHeight) {
  textarea.style.height = 'auto';
  textarea.style.height = `${textarea.scrollHeight}px`;
  setinputtextValue(textarea.value);
}
// ✅ HANDLE SCENARIO DROPDOWN (react-select)
if (!e?.target && e?.name && e?.value?.scenario) {
  const noteKey = e.name;
  const ReflectionKey = e.name;
  const OverviewKey = e.name;
  const ScenarioCompletionKey = e.name;
  const KeyInsightsKey = e.name;
  const SwipeMiniGameKey = e.name;
  const PreAssessment = e.name;
  const PostAssessment = e.name;
  const LinkKey = e.name;
      const WehaveChooseKey = e.name;
  const dialogKey = e.name;
  const interactionKey = e.name

  setInput((prevInput: any) => ({
    ...prevInput,
    [interactionKey]: {
      ...prevInput[interactionKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [noteKey]: {
      ...prevInput[noteKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [ReflectionKey]: {
      ...prevInput[ReflectionKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [OverviewKey]: {
      ...prevInput[OverviewKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [ScenarioCompletionKey]: {
      ...prevInput[ScenarioCompletionKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [KeyInsightsKey]: {
      ...prevInput[KeyInsightsKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [SwipeMiniGameKey]: {
      ...prevInput[SwipeMiniGameKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [PreAssessment]: {
      ...prevInput[PreAssessment],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [PostAssessment]: {
      ...prevInput[PostAssessment],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [LinkKey]: {
      ...prevInput[LinkKey],
      scenario: e.value.scenario,
    },
  }));
  setInput((prevInput: any) => ({
    ...prevInput,
    [dialogKey]: {
      ...prevInput[dialogKey],
      scenario: e.value.scenario,
    },
  }));
      setInput((prevInput: any) => ({
        ...prevInput,
        [WehaveChooseKey]: {
          ...prevInput[WehaveChooseKey],
          scenario: e.value.scenario,
        },
      }));
 

  return; // ⛔ stop further textarea logic
}


    const getLastDigit = e.target.name.slice(-1);
    const match = e.target.name.match(/([a-zA-Z]+)(\d+)/);
    if (match) {
      const textPart = match[1];
      const numberPart = match[2];
    } else {
      return false;
    }
    setBlockNumber(BlockNum);
    setLastInputName(Number(match[2]));
    setInput((prevInput: any) => {
      const noteKey = `Note${items[i]?.input}`;
      const LinkKey = `Link${items[i]?.input}`;
      const DragForNowKey = `DragForNow${items[i]?.input}`;
      const WehaveChooseKey = `WehaveChoose${items[i]?.input}`;
      const KeyInsightsKey = `KeyInsights${items[i]?.input}`;
      const SwipeMiniGameKey = `SwipeMiniGame${items[i]?.input}`;
      const PreAssessmentKey = `PreAssessment${items[i]?.input}`;
      const PostAssessmentKey = `PostAssessment${items[i]?.input}`;
      const OverviewKey = `Overview${items[i]?.input}`;
      const ScenarioCompletionKey = `ScenarioCompletion${items[i]?.input}`;
    
      const ReflectionKey = `Reflection${items[i]?.input}`;
      const dialogKey = `Dialog${items[i]?.input}`;
      const interactionKey = `Interaction${items[i]?.input}`;

      if (e.target.name == noteKey) {
        const note =
          e.target.id === 'Note' ? e.target.value : prevInput[noteKey]?.note;

           const smallNote =
    e.target.id === 'NoteSmall'
      ? e.target.value
      : prevInput[noteKey]?.smallNote;


        // if (note != '') {
        //   setValidation({
        //     ...validation,
        //     [`Note${BlockNum}`]: false,
        //   });
        // }
        if (note || smallNote) {
    setValidation({
      ...validation,
      [`Note${BlockNum}`]: false,
    });
  }
        return {
          ...prevInput,
          [noteKey]: {
            ...prevInput[noteKey],
            id: items[i]?.id,
            note: note,
             smallNote: smallNote,
          },
        };
      }

      if (e.target.name == LinkKey) {
        const Link =
          e.target.id === 'Link' ? e.target.value : prevInput[LinkKey]?.Link;

        if (Link != '') {
          setValidation({
            ...validation,
            [`Link${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [LinkKey]: {
            ...prevInput[LinkKey],
            id: items[i]?.id,
            Link: Link,
          },
        };
      }
      
       if (e.target.name == SwipeMiniGameKey) {

        const SwipeMiniGame = e.target.id === 'SwipeMiniGame' ? e.target.value : prevInput[SwipeMiniGameKey]?.SwipeMiniGame;
        const MiniTitle = e.target.id === 'MiniTitle' ? e.target.value : prevInput[SwipeMiniGameKey]?.MiniTitle;
        const leftOption = e.target.id === 'leftOption' ? e.target.value : prevInput[SwipeMiniGameKey]?.leftOption;
        const rightOption = e.target.id === 'rightOption' ? e.target.value : prevInput[SwipeMiniGameKey]?.rightOption;
        const instructionText = e.target.id === 'instructionText' ? e.target.value : prevInput[SwipeMiniGameKey]?.instructionText;
        const statementLabel = e.target.id === 'statementLabel' ? e.target.value : prevInput[SwipeMiniGameKey]?.statementLabel;
        const scenario = e.target.id === 'scenario' ? e.target.value : prevInput[SwipeMiniGameKey]?.scenario;
        // const MiniSubTitle1 = e.target.id === 'MiniSubTitle1' ? e.target.value : prevInput[SwipeMiniGameKey]?.MiniSubTitle1;
        const PointsPerCorrectScore = e.target.id === 'PointsPerCorrectScore' ? e.target.value : prevInput[SwipeMiniGameKey]?.PointsPerCorrectScore;
        const CorrectAnswerFeedback = e.target.id === 'CorrectAnswerFeedback' ? e.target.value : prevInput[SwipeMiniGameKey]?.CorrectAnswerFeedback;
        const WrongAnswerFeedback = e.target.id === 'WrongAnswerFeedback' ? e.target.value : prevInput[SwipeMiniGameKey]?.WrongAnswerFeedback;
        const Streak2message = e.target.id === 'Streak2message' ? e.target.value : prevInput[SwipeMiniGameKey]?.Streak2message;
        const Streak3message = e.target.id === 'Streak3message' ? e.target.value : prevInput[SwipeMiniGameKey]?.Streak3message;
        const Streak4message = e.target.id === 'Streak4message' ? e.target.value : prevInput[SwipeMiniGameKey]?.Streak4message;
        const Streak5message = e.target.id === 'Streak5message' ? e.target.value : prevInput[SwipeMiniGameKey]?.Streak5message;
        const AnswerGuide = e.target.id === 'AnswerGuide' ? e.target.value : prevInput[SwipeMiniGameKey]?.AnswerGuide;
        const Timerlimit = e.target.id === 'Timerlimit' ? e.target.value : prevInput[SwipeMiniGameKey]?.Timerlimit;
        const timerEnabled = e.target.id === "timerEnabled" ? e.target.value === true : prevInput[SwipeMiniGameKey]?.timerEnabled;
        const ShowReplay = e.target.id === 'ShowReplay' ? e.target.value : prevInput[SwipeMiniGameKey]?.ShowReplay;
        const answerGuideEnabled = e.target.id === "answerGuideEnabled" ? e.target.value : prevInput[SwipeMiniGameKey]?.answerGuideEnabled;

        const Minlowscore = e.target.id === 'Minlowscore' ? e.target.value : prevInput[SwipeMiniGameKey]?.Minlowscore;
        const Maxlowscore = e.target.id === 'Maxlowscore' ? e.target.value : prevInput[SwipeMiniGameKey]?.Maxlowscore;
        const LowScoreMessage = e.target.id === 'LowScoreMessage' ? e.target.value : prevInput[SwipeMiniGameKey]?.LowScoreMessage;
        const Minmediumscore = e.target.id === 'Minmediumscore' ? e.target.value : prevInput[SwipeMiniGameKey]?.Minmediumscore;
        const Maxmediumscore = e.target.id === 'Maxmediumscore' ? e.target.value : prevInput[SwipeMiniGameKey]?.Maxmediumscore;
        const MediumScoreMessage = e.target.id === 'MediumScoreMessage' ? e.target.value : prevInput[SwipeMiniGameKey]?.MediumScoreMessage;
        const Minhighscore = e.target.id === 'Minhighscore' ? e.target.value : prevInput[SwipeMiniGameKey]?.Minhighscore;
        const Maxhighscore = e.target.id === 'Maxhighscore' ? e.target.value : prevInput[SwipeMiniGameKey]?.Maxhighscore;
        const highScoreMessage = e.target.id === 'highScoreMessage' ? e.target.value : prevInput[SwipeMiniGameKey]?.highScoreMessage;
        const roundLogic = e.target.id === "roundLogic" ? e.target.value : prevInput[SwipeMiniGameKey]?.roundLogic;

        if (SwipeMiniGame != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (MiniTitle != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (scenario != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (leftOption != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (rightOption != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (instructionText != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (statementLabel != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (PointsPerCorrectScore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (CorrectAnswerFeedback != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (WrongAnswerFeedback != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
         if (Streak2message != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Streak3message != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Streak4message != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Streak5message != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        
        if (AnswerGuide != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Timerlimit != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (ShowReplay != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Minlowscore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Maxlowscore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Minmediumscore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Maxmediumscore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (LowScoreMessage != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (MediumScoreMessage != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Minhighscore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (Maxhighscore != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (highScoreMessage != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (roundLogic != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (timerEnabled != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        if (answerGuideEnabled != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...prevInput[SwipeMiniGameKey],
            id: items[i]?.id,
            MiniTitle: MiniTitle,
            SwipeMiniGame: SwipeMiniGame,
            leftOption: leftOption,
            rightOption: rightOption,
            instructionText: instructionText,
            statementLabel: statementLabel,
            scenario: scenario,
            MiniTopic: leftOption,
            // MiniSubTitle1: MiniSubTitle1,
            PointsPerCorrectScore: PointsPerCorrectScore,
            CorrectAnswerFeedback: CorrectAnswerFeedback,
            WrongAnswerFeedback: WrongAnswerFeedback,
            Streak2message: Streak2message,
            Streak3message: Streak3message,
            Streak4message: Streak4message,
            Streak5message: Streak5message,
            AnswerGuide: AnswerGuide,
            ShowReplay: ShowReplay,
            Minlowscore: Minlowscore,
            Maxlowscore: Maxlowscore,
            Minmediumscore: Minmediumscore,
            Maxmediumscore: Maxmediumscore,
            LowScoreMessage: LowScoreMessage,
            MediumScoreMessage: MediumScoreMessage,
            Minhighscore: Minhighscore,
            Maxhighscore: Maxhighscore,
            highScoreMessage: highScoreMessage,
            roundLogic: roundLogic,
            timerEnabled: timerEnabled,
            Timerlimit: Timerlimit,
            answerGuideEnabled: answerGuideEnabled,
          },
        };
      }
      if (e.target.name == DragForNowKey) {

        const DragForNow = e.target.id === 'DragForNow' ? e.target.value : prevInput[DragForNowKey]?.DragForNow;
        const MiniTitle = e.target.id === 'MiniTitle' ? e.target.value : prevInput[DragForNowKey]?.MiniTitle;
        const GameMode = e.target.id === 'GameMode' ? e.target.value : prevInput[DragForNowKey]?.GameMode;
        // const leftOption = e.target.id === 'leftOption' ? e.target.value : prevInput[DragForNowKey]?.leftOption;
        // const rightOption = e.target.id === 'rightOption' ? e.target.value : prevInput[DragForNowKey]?.rightOption;
        // const instructionText = e.target.id === 'instructionText' ? e.target.value : prevInput[DragForNowKey]?.instructionText;
        // const statementLabel = e.target.id === 'statementLabel' ? e.target.value : prevInput[DragForNowKey]?.statementLabel;
        // const scenario = e.target.id === 'scenario' ? e.target.value : prevInput[DragForNowKey]?.scenario;
        const PointsPerCorrectScore = e.target.id === 'PointsPerCorrectScore' ? e.target.value : prevInput[DragForNowKey]?.PointsPerCorrectScore;
        // const CorrectAnswerFeedback = e.target.id === 'CorrectAnswerFeedback' ? e.target.value : prevInput[DragForNowKey]?.CorrectAnswerFeedback;
        // const WrongAnswerFeedback = e.target.id === 'WrongAnswerFeedback' ? e.target.value : prevInput[DragForNowKey]?.WrongAnswerFeedback;
        const Streak2message = e.target.id === 'Streak2message' ? e.target.value : prevInput[DragForNowKey]?.Streak2message;
        const Streak3message = e.target.id === 'Streak3message' ? e.target.value : prevInput[DragForNowKey]?.Streak3message;
        const Streak4message = e.target.id === 'Streak4message' ? e.target.value : prevInput[DragForNowKey]?.Streak4message;
        const Streak5message = e.target.id === 'Streak5message' ? e.target.value : prevInput[DragForNowKey]?.Streak5message;
        const AnswerGuide = e.target.id === 'AnswerGuide' ? e.target.value : prevInput[DragForNowKey]?.AnswerGuide;
        const Timerlimit = e.target.id === 'Timerlimit' ? e.target.value : prevInput[DragForNowKey]?.Timerlimit;
        const timerEnabled = e.target.id === "timerEnabled" ? e.target.value === true : prevInput[DragForNowKey]?.timerEnabled;
        const ShowReplay = e.target.id === 'ShowReplay' ? e.target.value : prevInput[DragForNowKey]?.ShowReplay;
        const answerGuideEnabled = e.target.id === "answerGuideEnabled" ? e.target.value : prevInput[DragForNowKey]?.answerGuideEnabled;

        const Minlowscore = e.target.id === 'Minlowscore' ? e.target.value : prevInput[DragForNowKey]?.Minlowscore;
        const Maxlowscore = e.target.id === 'Maxlowscore' ? e.target.value : prevInput[DragForNowKey]?.Maxlowscore;
        const LowScoreMessage = e.target.id === 'LowScoreMessage' ? e.target.value : prevInput[DragForNowKey]?.LowScoreMessage;
        const Minmediumscore = e.target.id === 'Minmediumscore' ? e.target.value : prevInput[DragForNowKey]?.Minmediumscore;
        const Maxmediumscore = e.target.id === 'Maxmediumscore' ? e.target.value : prevInput[DragForNowKey]?.Maxmediumscore;
        const MediumScoreMessage = e.target.id === 'MediumScoreMessage' ? e.target.value : prevInput[DragForNowKey]?.MediumScoreMessage;
        const Minhighscore = e.target.id === 'Minhighscore' ? e.target.value : prevInput[DragForNowKey]?.Minhighscore;
        const Maxhighscore = e.target.id === 'Maxhighscore' ? e.target.value : prevInput[DragForNowKey]?.Maxhighscore;
        const highScoreMessage = e.target.id === 'highScoreMessage' ? e.target.value : prevInput[DragForNowKey]?.highScoreMessage;
        const roundLogic = e.target.id === "roundLogic" ? e.target.value : prevInput[DragForNowKey ]?.roundLogic;
      console.log("roundLogicroundLogic", roundLogic)
        if (DragForNow != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (MiniTitle != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (GameMode != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        // if (scenario != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
        // if (leftOption != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
        // if (rightOption != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
        // if (instructionText != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
        // if (statementLabel != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
        if (PointsPerCorrectScore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        // if (CorrectAnswerFeedback != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
        // if (WrongAnswerFeedback != '') {
        //   setValidation({
        //     ...validation,
        //     [`DragForNow${BlockNum}`]: false,
        //   });
        // }
         if (Streak2message != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Streak3message != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Streak4message != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Streak5message != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        
        if (AnswerGuide != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Timerlimit != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (ShowReplay != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Minlowscore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Maxlowscore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Minmediumscore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Maxmediumscore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (LowScoreMessage != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (MediumScoreMessage != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Minhighscore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (Maxhighscore != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (highScoreMessage != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (roundLogic != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (timerEnabled != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        if (answerGuideEnabled != '') {
          setValidation({
            ...validation,
            [`DragForNow${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [DragForNowKey]: {
            ...prevInput[DragForNowKey],
            id: items[i]?.id,
            MiniTitle: MiniTitle,
            GameMode: GameMode,
            DragForNow: DragForNow,
            // leftOption: leftOption,
            // rightOption: rightOption,
            // instructionText: instructionText,
            // statementLabel: statementLabel,
            // scenario: scenario,
            // MiniTopic: leftOption,
            // MiniSubTitle1: MiniSubTitle1,
            PointsPerCorrectScore: PointsPerCorrectScore,
            // CorrectAnswerFeedback: CorrectAnswerFeedback,
            // WrongAnswerFeedback: WrongAnswerFeedback,
            Streak2message: Streak2message,
            Streak3message: Streak3message,
            Streak4message: Streak4message,
            Streak5message: Streak5message,
            AnswerGuide: AnswerGuide,
            ShowReplay: ShowReplay,
            Minlowscore: Minlowscore,
            Maxlowscore: Maxlowscore,
            Minmediumscore: Minmediumscore,
            Maxmediumscore: Maxmediumscore,
            LowScoreMessage: LowScoreMessage,
            MediumScoreMessage: MediumScoreMessage,
            Minhighscore: Minhighscore,
            Maxhighscore: Maxhighscore,
            highScoreMessage: highScoreMessage,
            roundLogic: roundLogic,
            timerEnabled: timerEnabled,
            Timerlimit: Timerlimit,
            answerGuideEnabled: answerGuideEnabled,
          },
        };
      }
      if (e.target.name == WehaveChooseKey) {
        const WehaveChoose = e.target.id === 'WehaveChoose' ? e.target.value : prevInput[WehaveChooseKey]?.WehaveChoose;
        const MiniTitle = e.target.id === 'MiniTitle' ? e.target.value : prevInput[WehaveChooseKey]?.MiniTitle;
        const scenario = e.target.id === 'scenario' ? e.target.value : prevInput[WehaveChooseKey]?.scenario;
        const MiniTopic = e.target.id === 'MiniTopic' ? e.target.value : prevInput[WehaveChooseKey]?.MiniTopic;
        const MiniSubTitle1 = e.target.id === 'MiniSubTitle1' ? e.target.value : prevInput[WehaveChooseKey]?.MiniSubTitle1;
        const MiniCharacterSubTitle2 = e.target.id === 'MiniCharacterSubTitle2' ? e.target.value : prevInput[WehaveChooseKey]?.MiniCharacterSubTitle2;
        const PointsPerCorrectScore = e.target.id === 'PointsPerCorrectScore' ? e.target.value : prevInput[WehaveChooseKey]?.PointsPerCorrectScore;
        const CorrectAnswerFeedback = e.target.id === 'CorrectAnswerFeedback' ? e.target.value : prevInput[WehaveChooseKey]?.CorrectAnswerFeedback;
        const WrongAnswerFeedback = e.target.id === 'WrongAnswerFeedback' ? e.target.value : prevInput[WehaveChooseKey]?.WrongAnswerFeedback;
        const AnswerGuide = e.target.id === 'AnswerGuide' ? e.target.value : prevInput[WehaveChooseKey]?.AnswerGuide;
        const Timerlimit = e.target.id === 'Timerlimit' ? e.target.value : prevInput[WehaveChooseKey]?.Timerlimit;
       const timerEnabled =e.target.id === "timerEnabled"? e.target.value === true: prevInput[WehaveChooseKey]?.timerEnabled;
       const ShowReplay =e.target.id === 'ShowReplay'? e.target.value: prevInput[WehaveChooseKey]?.ShowReplay;
       const answerGuideEnabled = e.target.id === "answerGuideEnabled"? e.target.value: prevInput[WehaveChooseKey]?.answerGuideEnabled;

        const Minlowscore = e.target.id === 'Minlowscore' ? e.target.value : prevInput[WehaveChooseKey]?.Minlowscore;
        const Maxlowscore = e.target.id === 'Maxlowscore' ? e.target.value : prevInput[WehaveChooseKey]?.Maxlowscore;
        const LowScoreMessage = e.target.id === 'LowScoreMessage' ? e.target.value : prevInput[WehaveChooseKey]?.LowScoreMessage;
        const Minmediumscore = e.target.id === 'Minmediumscore' ? e.target.value : prevInput[WehaveChooseKey]?.Minmediumscore;
        const Maxmediumscore = e.target.id === 'Maxmediumscore' ? e.target.value : prevInput[WehaveChooseKey]?.Maxmediumscore;
        const MediumScoreMessage = e.target.id === 'MediumScoreMessage' ? e.target.value : prevInput[WehaveChooseKey]?.MediumScoreMessage;
        const Minhighscore = e.target.id === 'Minhighscore' ? e.target.value : prevInput[WehaveChooseKey]?.Minhighscore;
        const Maxhighscore = e.target.id === 'Maxhighscore' ? e.target.value : prevInput[WehaveChooseKey]?.Maxhighscore;
        const highScoreMessage = e.target.id === 'highScoreMessage' ? e.target.value : prevInput[WehaveChooseKey]?.highScoreMessage;
        
        const roundLogic =
          e.target.id === "roundLogic"
            ? e.target.value
            : prevInput[WehaveChooseKey]?.roundLogic;
        if (WehaveChoose != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (MiniTitle != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (scenario != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (MiniTopic != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (MiniSubTitle1 != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (MiniCharacterSubTitle2 != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (PointsPerCorrectScore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (CorrectAnswerFeedback != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (WrongAnswerFeedback != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (AnswerGuide != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Timerlimit != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (ShowReplay!= '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Minlowscore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Maxlowscore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Minmediumscore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Maxmediumscore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (LowScoreMessage != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (MediumScoreMessage != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Minhighscore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (Maxhighscore != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (highScoreMessage != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (roundLogic != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (timerEnabled != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }
        if (answerGuideEnabled != '') {
          setValidation({
            ...validation,
            [`WehaveChoose${BlockNum}`]: false,
          });
        }

        return {
          ...prevInput,
          [WehaveChooseKey]: {
            ...prevInput[WehaveChooseKey],
            id: items[i]?.id,
            MiniTitle: MiniTitle,
            WehaveChoose: WehaveChoose,
            scenario: scenario,
            MiniTopic: MiniTopic,
            MiniSubTitle1: MiniSubTitle1,
            MiniCharacterSubTitle2:MiniCharacterSubTitle2,
            PointsPerCorrectScore: PointsPerCorrectScore,
            CorrectAnswerFeedback: CorrectAnswerFeedback,
            WrongAnswerFeedback: WrongAnswerFeedback,
            AnswerGuide: AnswerGuide,
            ShowReplay: ShowReplay ,
            Minlowscore: Minlowscore,
            Maxlowscore: Maxlowscore,
            Minmediumscore: Minmediumscore,
            Maxmediumscore: Maxmediumscore,
            LowScoreMessage: LowScoreMessage,
            MediumScoreMessage: MediumScoreMessage,
            Minhighscore: Minhighscore,
            Maxhighscore: Maxhighscore,
            highScoreMessage: highScoreMessage,
            roundLogic: roundLogic,
            timerEnabled: timerEnabled,
            Timerlimit: Timerlimit,
            answerGuideEnabled: answerGuideEnabled,
          },
        };
      }
      if (e.target.name == KeyInsightsKey) {
        const KeyInsights =
          e.target.id === 'KeyInsights' ? e.target.value : prevInput[KeyInsightsKey]?.KeyInsights;

        if (KeyInsights != '') {
          setValidation({
            ...validation,
            [`KeyInsights${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [KeyInsightsKey]: {
            ...prevInput[KeyInsightsKey],
            id: items[i]?.id,
            KeyInsights: KeyInsights,
          },
        };
      }
      if (e.target.name == SwipeMiniGameKey) {
        const SwipeMiniGame =
          e.target.id === 'SwipeMiniGame' ? e.target.value : prevInput[SwipeMiniGameKey]?.SwipeMiniGame;

        if (SwipeMiniGame != '') {
          setValidation({
            ...validation,
            [`SwipeMiniGame${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...prevInput[SwipeMiniGameKey],
            id: items[i]?.id,
            SwipeMiniGame: SwipeMiniGame,
          },
        };
      }
      if (e.target.name == PreAssessmentKey) {
        const PreAssessment =
          e.target.id === 'PreAssessment' ? e.target.value : prevInput[PreAssessmentKey]?.PreAssessment;
        const validatePrompt =
          e.target.id === 'validatePrompt' ? e.target.value : prevInput[PreAssessmentKey]?.validatePrompt;
        const evaluationPrompt =
          e.target.id === 'evaluationPrompt' ? e.target.value : prevInput[PreAssessmentKey]?.evaluationPrompt;
        const uploadedImage = e.target.id === 'uploadedImage' ? e.target.value : prevInput[PreAssessmentKey]?.uploadedImage;

        if (PreAssessment != '') {
          setValidation({
            ...validation,
            [`PreAssessment${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [PreAssessmentKey]: {
            ...prevInput[PreAssessmentKey],
            id: items[i]?.id,
            PreAssessment: PreAssessment,
            validatePrompt: validatePrompt,
            evaluationPrompt: evaluationPrompt,
            uploadedImage: uploadedImage,
          },
        };
      }
      if (e.target.name == PostAssessmentKey) {
        const PostAssessment =
          e.target.id === 'PostAssessment' ? e.target.value : prevInput[PostAssessmentKey]?.PostAssessment;
        const validatePrompt =
          e.target.id === 'validatePrompt' ? e.target.value : prevInput[PostAssessmentKey]?.validatePrompt;
        const evaluationPrompt =
          e.target.id === 'evaluationPrompt' ? e.target.value : prevInput[PostAssessmentKey]?.evaluationPrompt;
         const uploadedImage = e.target.id === 'uploadedImage' ? e.target.value : prevInput[PostAssessmentKey]?.uploadedImage;

        if (PostAssessment != '') {
          setValidation({
            ...validation,
            [`PostAssessment${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [PostAssessmentKey]: {
            ...prevInput[PostAssessmentKey],
            id: items[i]?.id,
            PostAssessment: PostAssessment,
            validatePrompt: validatePrompt,
            evaluationPrompt: evaluationPrompt,
            uploadedImage: uploadedImage,
          },
        };
      }
      if (e.target.name == OverviewKey) {
        const Overview =
          e.target.id === 'Overview' ? e.target.value : prevInput[OverviewKey]?.Overview;

        if (Overview != '') {
          setValidation({
            ...validation,
            [`Overview${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [OverviewKey]: {
            ...prevInput[OverviewKey],
            id: items[i]?.id,
            Overview: Overview,
          },
        };
      }

      //scenario comp
      //  if (e.target.name == ScenarioCompletionKey) {
      //   const ScenarioCompletion =
      //     e.target.id === 'ScenarioCompletion' ? e.target.value : prevInput[ScenarioCompletionKey]?.ScenarioCompletion;

      //   if (ScenarioCompletion != '') {
      //     setValidation({
      //       ...validation,
      //       [`ScenarioCompletion${BlockNum}`]: false,
      //     });
      //   }
      //   return {
      //     ...prevInput,
      //     [ScenarioCompletionKey]: {
      //       ...prevInput[ScenarioCompletionKey],
      //       id: items[i]?.id,
      //       ScenarioCompletion: ScenarioCompletion,
      //     },
      //   };
      // }
    if (e.target.name === ScenarioCompletionKey) {
  return {
    ...prevInput,
    [ScenarioCompletionKey]: {
      ...prevInput[ScenarioCompletionKey],
      id: items[i]?.id,
      [e.target.id]: e.target.value,
    },
  };
}
     
      if (e.target.name == ReflectionKey) {
        const Reflection =
          e.target.id === 'Reflection' ? e.target.value : prevInput[ReflectionKey]?.Reflection;

        if (Reflection != '') {
          setValidation({
            ...validation,
            [`Reflection${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [ReflectionKey]: {
            ...prevInput[ReflectionKey],
            id: items[i]?.id,
            Reflection: Reflection,
          },
        };
      }

      if (e.target.name == dialogKey) {
        const dialog =
          e.target.id === 'Dialog'
            ? e.target.value
            : prevInput[dialogKey]?.dialog;

        if (dialog != '') {
          setValidation({
            ...validation,
            [`Dialog${BlockNum}`]: false,
          });
        }
        return {
          ...prevInput,
          [dialogKey]: {
            ...prevInput[dialogKey],
            id: items[i]?.id,
            dialog: dialog,
          },
        };
      }

      if (e.target.name == interactionKey) {
        const interaction =
          e.target.id === 'interaction'
            ? e.target.value
            : prevInput[interactionKey]?.interaction;

        const questionTitle =
          e.target.id === `QuestionTitle${items[i]?.input}`
            ? e.target.value
            : prevInput[interactionKey]?.quesionTitle;
        const scenario =
          e.target.id === `Scenario${items[i]?.input}`
            ? e.target.value
            : prevInput[interactionKey]?.scenario;
        const SkillTag =
          e.target.id === 'skills'
            ? e.target.value
            : prevInput[interactionKey]?.SkillTag;
        const PriorityTag =
          e.target.id === 'priority'
            ? e.target.value
            : prevInput[interactionKey]?.PriorityTag;

        const optionsObject: any = {};
        const responseObject: any = {};
        const feedbackObject: any = {};
        const checklistObject: any = {};
        const scoreObject: any = {};
        const ansObject: any = {};
        const optionTitleObject: any = {};
        const currentOptionId = e.target.id;
        const currentOptionTitle = e.target.title;
        const newOptionValue = e.target.value;

        // Duplicate check
        const existingOptions = prevInput[interactionKey]?.optionsObject || {};
        const optionValues = Object.entries(existingOptions).filter(
          ([key]) => key !== currentOptionTitle,
        );
        const isDuplicate = optionValues.some(
          ([key, val]) => val === newOptionValue,
        );

        if (isDuplicate) {
          console.warn(`⚠️ Duplicate option "${newOptionValue}" not allowed.`);
          return prevInput; // Skip update
        }

        alphabet.forEach((item: any) => {
          const optValue =
            e.target.id === `Option${e.target.title}`
              ? e.target.value
              : prevInput[interactionKey]?.optionsObject?.[item.option];
          const responseValue =
            e.target.id === `Response${e.target.title}`
              ? e.target.value
              : prevInput[interactionKey]?.responseObject?.[item.option];
          const feedbackValue =
            e.target.id === `FeedBack${e.target.title}`
              ? e.target.value
              : prevInput[interactionKey]?.feedbackObject?.[item.option];
          const checklistValue =
            e.target.id === `Checklist${e.target.title}`
              ? e.target.value
              : prevInput[interactionKey]?.checklistObject?.[item.option];
          const scoreValue =
            e.target.id === `Score${e.target.title}`
              ? e.target.value
              : prevInput[interactionKey]?.scoreObject?.[item.option];

          const ansValue =
            e.target.id === `Ans${e.target.title}`
              ? e.target.checked
              : prevInput[interactionKey]?.ansObject?.[item.option];
          const optionTitleValue =
            e.target.id === `OptionTitle${e.target.title}`
              ? e.target.value
              : prevInput[interactionKey]?.optionTitleObject?.[item.option];

          optionsObject[item.option] =
            e.target.id === `Option${item.option}`
              ? optValue
              : prevInput[interactionKey]?.optionsObject?.[item.option];

          responseObject[item.option] =
            e.target.id === `Response${item.option}`
              ? responseValue
              : prevInput[interactionKey]?.responseObject?.[item.option];

          feedbackObject[item.option] =
            e.target.id === `FeedBack${item.option}`
              ? feedbackValue
              : prevInput[interactionKey]?.feedbackObject?.[item.option];
          checklistObject[item.option] =
            e.target.id === `Checklist${item.option}`
              ? checklistValue
              : prevInput[interactionKey]?.checklistObject?.[item.option];

          scoreObject[item.option] =
            e.target.id === `Score${item.option}`
              ? scoreValue
              : prevInput[interactionKey]?.scoreObject?.[item.option];

          ansObject[item.option] =
            e.target.id === `Ans${item.option}`
              ? ansValue
              : prevInput[interactionKey]?.ansObject?.[item.option];

          optionTitleObject[item.option] =
            e.target.id === `OptionTitle${item.option}`
              ? optionTitleValue
              : prevInput[interactionKey]?.optionTitleObject?.[item.option];
        });

        if (interaction != '') {
          setValidation({
            ...validation,
            [`Interaction${BlockNum}`]: false,
          });
        }
        for (const alp of alphabet?.filter(
          (alp: any) => items[i]?.id === alp.seqs,
        ) || []) {
          handleValidation(
            alp,
            BlockNum,
            optionsObject,
            validation,
            setValidation,
          );
        }
        function handleValidation(
          alp: any,
          blockNum: any,
          optionsObject: any,
          currentValidation: any,
          setValidation: any,
        ) {
          const optionKey = `options${blockNum}${alp?.option}`;
          const isValid = optionsObject?.[alp?.option] === '' ? true : false;

          setValidation((prevValidation: any) => ({
            ...prevValidation,
            [optionKey]: isValid,
          }));

          if (validation?.[`score${BlockNum}`]) {
            const scoreValid: any = Object.values(scoreObject).find(
              (item: any) => item,
            );

            if (scoreValid > 0) {
              setValidation({
                ...validation,
                [`Interaction${BlockNum}`]: false,
                [`score${BlockNum}`]: false,
              });
            }
          }
        }

        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: items[i]?.id,
            // scenario: prevInput[interactionKey]?.scenario || null,
            SkillTag: SkillTag,
            PriorityTag:PriorityTag,
            interaction: interaction,
            quesionTitle: questionTitle,
            scenario: scenario,
            optionTitleObject: optionTitleObject,
            responseObject,
            feedbackObject,
            checklistObject,
            optionsObject,
            scoreObject,
            ansObject,
          },
        };
      }

    });
  };
  const handleSelect = (selectedOption: any, e: any, data: string) => {
    const getLastDigit = e.name.slice(-1);
    const match = e.name.match(/([a-zA-Z]+)(\d+)/);
    setLastInputName(Number(match[2]));
    const value = selectedOption ? selectedOption : '';
    setInput((prevInput: any) => {
      return {
        ...prevInput,
        [e.name]: {
          ...prevInput[e.name],
          character: data === 'character' ? value : prevInput[e.name].character,
          animation: data === 'animation' ? value : prevInput[e.name].animation,
          voice: data === 'voice' ? value : prevInput[e.name].voice,
        },
      };
    });
  };

  // Items will change based on sequence state
  useEffect(() => {
    const updatedSeq = sequence.map(
      (item: any, index: number) => dummySequence[index] || item.id,
    );

    const updatedItems = items.map((item: any, index: number) => ({
      ...item,
      id: updatedSeq[index] || item.id,
      upNext: upNextCount[index],
    }));

    const updateInteraction = items.map((item: any, index: number) => {
      if (item?.type === 'Interaction') {
        return { ...item, from: item.id, to: updatedSeq[index] || item.id };
      }
      return null; // Return null for items that don't meet the condition
    });

    const updatedAlphabet = alphabet.map((item: MyObject) => {
      // Find the corresponding updateInteraction item
      const correspondingUpdate = updateInteraction.find(
        (updateItem: any) => updateItem?.from === item.seqs,
      );
      // If a corresponding updateInteraction item is found, update the seqs value
      if (correspondingUpdate) {
        return { ...item, seqs: correspondingUpdate.to };
      }

      // If no corresponding updateInteraction item is found, return the original item
      return item;
    });

    setAlphabet(updatedAlphabet);

    setItems(updatedItems);
    setBlockItems(updatedItems);
  }, [sequence, dummySequence, id]);
  // upNext count will change based on last Items
  useEffect(() => {
    const data = items.slice(-12);
    const getFilter = data.find((item: any) => item);
    const getUpNext = getFilter?.upNext;
    setUpNext(getUpNext);
  }, [items]);

  useEffect(() => {
    if (isDeleteSeq) {
      const updatedSeq = sequence.map(
        (item: any, index: number) => dummySequence[index] || item.id,
      );

      const updatedItems = items.map((item: any, index: number) => ({
        ...item,
        id: updatedSeq[index] || item.id,
        upNext: upNextCount[index],
      }));
      const updateInteraction = items.map((item: any, index: number) => {
        if (item?.type === 'Interaction') {
          return { ...item, from: item.id, to: updatedSeq[index] || item.id };
        }
        return null; // Return null for items that don't meet the condition
      });

      const updatedAlphabet = alphabet.map((item: MyObject) => {
        // Find the corresponding updateInteraction item
        const correspondingUpdate = updateInteraction.find(
          (updateItem: any) => updateItem?.from === item.seqs,
        );
        // If a corresponding updateInteraction item is found, update the seqs value
        if (correspondingUpdate) {
          return { ...item, seqs: correspondingUpdate.to };
        }

        // If no corresponding updateInteraction item is found, return the original item
        return item;
      });
      setAlphabet(updatedAlphabet);

      setItems(updatedItems);
      setBlockItems(updatedItems);

      setDeleteseq(false);
    }
  }, [isDeleteSeq]);

  const handleClickOutside = (event: any) => {
    const concernedElement = document.querySelector('.MiniShowBox');
    const concernedElementshowBox = document.querySelector('.showBox');
    if (concernedElement && !concernedElement.contains(event.target)) {
      setShowMiniBox(false);
    }
    if (
      concernedElementshowBox &&
      !concernedElementshowBox.contains(event.target)
    ) {
      setShowBox(false);
    }
  };

  // components
  const MiniBox = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'absolute'}
        background={'#fff'}
        p={'10px'}
        top={'50px'}
        left={'0px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
        <List cursor={'pointer'}>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'Note')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
            Note
          </ListItem>

          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'Dialog')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
            Dialog
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'Interaction')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
          >
            <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
            Interaction
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'Link')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
            Link
          </ListItem>
           {showReflectionQuestions && (
            <>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'Reflection')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
            Reflection
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'Overview')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
            Overview
          </ListItem>
              <ListItem
                onClick={() => handleMiniNDI(seq, i, 'ScenarioCompletion')}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                ScenarioCompletion
              </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'KeyInsights')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
            KeyInsights
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'SwipeMiniGame')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
            SwipeMiniGame
          </ListItem>
	  <ListItem
            onClick={() => handleMiniNDI(seq, i, 'PreAssessment')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
            PreAssessment
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'PostAssessment')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
            PostAssessment
          </ListItem>
          
            {showScenarioCompletion && formData?.gameScenarioCompletion === "true" && (
               <ListItem
            onClick={() => handleMiniNDI(seq, i, 'ScenarioCompletion')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
            ScenarioCompletion
          </ListItem>
           )}
          </>
           )}
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'WehaveChoose')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
            WehaveChoose
             </ListItem>
          <ListItem
            onClick={() => handleMiniNDI(seq, i, 'DragForNow')}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
            DragForNow
          </ListItem>
        </List>
      </Box>
    );
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const textColor = useColorModeValue('secondaryGray.900', 'white');

  useEffect(() => {
    if (reviews.length > 0) {
      const blockSeqArray: string[] = [];
      reviews.forEach((review: any) => {
        if (review?.tabId === 4 && review?.tabAttribute === 'blockSeqId') {
          const tableSeqId = review?.blockSecondaryId;
          blockSeqArray.push(tableSeqId);
        }
      });
      const blockSeqSet = new Set(blockSeqArray);
      // Get all Values
      const myIterator = blockSeqSet.values();
      // List all Values
      for (const seq of myIterator) {
        getBlockReadUnreadCount(seq);
      }
    }
  }, [reviews]);
  const getBlockReadUnreadCount = async (seqId: string) => {
    const result = { readCount: 0, unReadCount: 0, Total: 0 };
    /** get the reviews of blockSeq  */
    const filteredBlockReviews =
      reviews &&
      reviews.filter((review: any) => {
        if (review?.tabId === 4 && review?.tabAttribute === 'blockSeqId') {
          const tableSeqId = review?.blockSecondaryId;
          if (seqId === tableSeqId) {
            if (review.readStatus === 0) {
              result.unReadCount++;
            } else if (review.readStatus === 1) {
              result.readCount++;
            }
            result.Total++;
            return true;
          }
        }
        return false;
      });
    setBlockWiseReviewCount((prev: any) => ({ ...prev, [seqId]: result }));
  };
  useEffect(() => {
    const fetchData = async () => {
      const data = {
        items: items,
        input: input,
        alphabet: alphabet,
      };

      try {
        const result = await storyEngAudio(id, JSON.stringify(data)); // Pass questNo directly
        if (result?.status !== 'Success') {
          return console.log('updateBackground error :' + result?.err);
        } else {
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    };
    fetchData(); // Call fetchData function when items change
  }, [items]);

  useEffect(() => {
    if (!scrollToElementEnabled) return;

    items.forEach((seq: any, i: any) => {
      const scrollToElement = (id: any) => {
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 500); // delay to ensure elements are rendered
      };

      if (
        validation &&
        (validation[`Note${seq.input}`] ||
          validation[`Dialog${seq.input}`] ||
          validation[`Interaction${seq.input}`] ||
          validation[`QuestionsEmotion${seq.input}`] ||
          validation[`dailogAnimation${seq.input}`] ||
          validation[`NavigationOption${seq.input}`] ||
          validation[`Navigation${seq.input}`])
      ) {
        scrollToElement(`tarSeqRef${seq.id}`);
        handleKeyDown('click', i, seq);
      }

      alphabet
        ?.filter((alp: any) => alp.seqs === seq.id)
        .forEach((alp: any) => {
          const optionValidation =
            validation?.[`options${seq.input}${alp.option}`];
          const questionOptionEmotion =
            validation?.[`optionsEmotion${seq.input}${alp.option}`];
          const checkBox = validation?.[`checkbox${seq.input}`];
          const score = validation?.[`score${seq.input}`];

          if (optionValidation || questionOptionEmotion) {
            handleKeyDown('click', i, seq);
            scrollToElement(`Option${alp.option}`);
          }

          if (checkBox) {
            handleKeyDown('click', i, seq);
            scrollToElement(`Ans${alp.option}`);
          }

          if (score) {
            handleKeyDown('click', i, seq);
            scrollToElement(`Score${alp.option}`);
          }
        });
    });
    setScrollToElementEnabled(false);
    setTimeout(() => {}, 500); // Adjust the delay time (in milliseconds) as needed
  }, [items, validation, alphabet]);

  useEffect(() => {
    if (!targetSequence) return;

    // Delay to wait for DOM updates (interaction close/render complete)
    setTimeout(() => {
      requestAnimationFrame(() => {
        const element = document.getElementById(
          `tarSeqRef${targetSequence.id}`,
        );
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }, 300); // Adjust based on your UI transition timing
  }, [targetSequence]);

  // seq.type ===
  const getBorderColor = (seq: any) => {
    let borderColor = 'unset';
    let focusSeqRef: any;
    let indexToFind: any;
    alphabet
      ?.filter((alp: any) => alp.seqs === seq.id)
      .forEach((alp: any) => {
        if (
          validation?.[`options${seq.input}${alp.option}`] ||
          validation?.[`optionsEmotion${seq.input}${alp.option}`] ||
          validation?.[`checkbox${seq.input}`] ||
          validation?.[`score${seq.input}`] ||
          validation[`Interaction${seq.input}`] ||
          validation[`QuestionsEmotion${seq.input}`] ||
          validation[`NavigationOption${seq.input}`]
        ) {
          borderColor = 'red';
        }
      });

    if (borderColor !== 'red' && seq.id === targetSequence?.id) {
      borderColor = '#3311db'; // Default to base color
    }

    return borderColor;
  };

  // getNoteBorderColor
  const getNoteBorderColor = (seq: any) => {
    let borderColor = 'unset';

    if (
      validation[`Note${seq.input}`] ||
      validation[`Navigation${seq.input}`]
    ) {
      borderColor = 'red';
    }

    if (borderColor !== 'red' && seq.id === targetSequence?.id) {
      borderColor = '#3311db'; // Default to base color
    }

    return borderColor;
  };
  const getDialogBorderColor = (seq: any) => {
    let borderColor = 'unset';

    if (
      validation[`Dialog${seq.input}`] ||
      validation[`dailogAnimation${seq.input}`] ||
      validation[`Navigation${seq.input}`]
    ) {
      borderColor = 'red';
    }

    if (borderColor !== 'red' && seq.id === targetSequence?.id) {
      borderColor = '#3311db';
    }

    return borderColor;
  };

  console.log('reviews in final', reviews);

  return (
    <>
      <Box
        mt={{ base: '0px', xl: '0px' }}
        className="NDI"
        position={'relative'}
      >
        <Text fontSize={22} fontWeight={800} mb={'20px'}>
          Story
        </Text>
        <NDITabs
          handleGet={handleGet}
          fetchBlocks={fetchBlocks}
          listQuest={listQuest}
          questTabState={questTabState}
          setQuestTabState={setQuestTabState}
          deleteQuest={deleteQuest}
          languages={languages}
          setIsDeleteActionDone={setIsDeleteActionDone}
        />
        <Box className="sequence-lists" mt={'40px'} w={'100%'}>
          <CustomAccordion
            items={items}
            setItems={setItems}
            sequence={sequence}
            dummySequence={dummySequence}
            upNextCount={upNextCount}
            setAlphabet={setAlphabet}
            alphabet={alphabet}
            setBlockItems={setBlockItems}
          >
            {(type || items) &&
              items.map((seq: any, i: number) => {
                const getBlockId: any = Object.entries<BlockItem>(
                  listBlockItems,
                ).find(([key, blocks]) => blocks.id === seq.id);
                const blockId = getBlockId ? getBlockId[1]?.blockId : null;

                return (
                  <Draggable key={seq.id} draggableId={seq.id} index={i}>
                    {(provided, dragData) => {
                      if (
                        provided.draggableProps.style &&
                        !Object.isFrozen(provided.draggableProps.style)
                      ) {
                        let transform = provided.draggableProps.style.transform;
                        if (transform) {
                          let t = transform.split(',')[1];
                          provided.draggableProps.style.transform =
                            'translate(0px,' + t;
                        }
                      }

                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Box key={i} className="block-item-type">
                            {seq.type === 'Note' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>Note</Text>
                                  <NoteCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    formData={formData}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'Note'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setNoteNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setNotelead}
                                    handleSelectBlock={handleNoteNavigation}
                                    items={items}
                                    setSelectBlock={setNotelead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />
                                  {/* Review Preview Accordian for Note*/}
                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'Note'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            ) 
                            : seq.type === 'Dialog' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getDialogBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  style={{
                                    backgroundColor: ShowReview
                                      ? reviews &&
                                        reviews.find((item: any) => {
                                          const tabAttributeValue = `${seq?.questNo}@${seq?.input}`;
                                          const isMatched =
                                            item?.tabAttributeValue ===
                                            tabAttributeValue;
                                          return isMatched;
                                        })
                                        ? '#E2E8F0'
                                        : ''
                                      : '',
                                    marginBottom: '10px', // Adjust the value as per your requirement
                                  }}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                >
                                  <Text color={'gray.400'}>Dialog</Text>
                                  <DialogCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    ShowReview={ShowReview}
                                    id={id}
                                    language={formData?.gamelanguageCode}
                                    seq={seq}
                                    targetSequence={targetSequence}
                                    index={i}
                                    name={'Dialog'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    input={input}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleSelect={handleSelect}
                                    characterOption={characterOption}
                                    // dialogOption={dialogOption}
                                    voicePoseOption={voicePoseOption}
                                    animateBtn={animateBtn}
                                    setAnimateBtn={setAnimateBtn}
                                    handleDialogEmotion={handleDialogEmotion}
                                    handleDialogVoice={handleDialogVoice}
                                    formData={formData}
                                    alphabet={alphabet}
                                    handleNDI={handleNDI}
                                    handleBlock={setDialoglead}
                                    setNavigation={setDialogNavigation}
                                    handleSelectBlock={handleDialogNavigation}
                                    items={items}
                                    handleDialogBlockRoll={
                                      handleDialogBlockRoll
                                    }
                                    showSelectBlock={showSelectBlock}
                                    setSelectBlock={setSelectBlock}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />
                                  {/* Accordian For Dialog Blocks */}
                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>

                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                .filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}
                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'Dialog'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                             : seq.type === 'Interaction' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  zIndex={0}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  style={{
                                    backgroundColor: ShowReview
                                      ? reviews &&
                                        reviews.find((item: any) => {
                                          const tabAttributeValue = `${seq?.questNo}@${seq?.input}`;
                                          const isMatched =
                                            item?.tabAttributeValue ===
                                            tabAttributeValue;
                                          return isMatched;
                                        })
                                        ? '#E2E8F0'
                                        : ''
                                      : '',
                                    marginBottom: '10px', // Adjust the value as per your requirement
                                    transition: 'height 1s ease',
                                  }}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                >
                                  <Text color={'gray.400'}>Interaction</Text>
                                  <InteractionCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    ShowReview={ShowReview}
                                    id={id}
                                    language={formData?.gamelanguageCode}
                                    seq={seq}
                                    targetSequence={targetSequence}
                                    index={i}
                                    name={'Interaction'}
                                    number={number}
                                    dummySequence={dummySequence}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    input={input}
                                    handleNDI={handleNDI}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleSelect={handleSelect}
                                    characterOption={characterOption}
                                    alphabet={alphabet}
                                    setAlphabet={setAlphabet}
                                    animateBtn={animateBtn}
                                    inputtextValue={inputtextValue}
                                    setAnimateBtn={setAnimateBtn}
                                    interactionBlock={interactionBlock}
                                    setInteractionBlock={setInteractionBlock}
                                    formData={formData}
                                    handleBlockRoll={handleBlockRoll}
                                    handleResponseRoll={handleResponseRoll}
                                    handleQuestionEmotion={
                                      handleQuestionEmotion
                                    }
                                    handleOptionEmotion={handleOptionEmotion}
                                    handleResponseEmotion={
                                      handleResponseEmotion
                                    }
                                    handleCheckBox={handleCheckBox}
                                    handleOptionVoice={handleOptionVoice}
                                    handleQuestionVoice={handleQuestionVoice}
                                    setNavigation={setNavigation}
                                    handleSelectBlock={handleSelectBlock}
                                    handleBlock={handleBlock}
                                    countalphabet={countalphabet}
                                    setAlphabetCount={setAlphabetCount}
                                    items={items}
                                    handleTagsChange={handleTagsChange}
                                    showSelectBlock={showSelectBlock}
                                    setSelectBlock={setSelectBlock}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />
                                  {/* Accordian for Interaction Blocks */}
                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                .filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}
                                  {seq.id == showMiniBox ? (
                                    <MiniBox
                                      seq={seq}
                                      i={i}
                                      name={'Interaction'}
                                    />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            ) 
                            : seq.type === 'Link' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>Link</Text>
                                  <UrlCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                   formData={formData}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'Link'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setLinkNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setLinklead}
                                    handleSelectBlock={handleLinkNavigation}
                                    items={items}
                                    setSelectBlock={setLinklead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'Link'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                            : seq.type === 'KeyInsights' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>KeyInsights</Text>
                                  <KeyInsightsCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    formData={formData}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'KeyInsights'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setKeyInsightsNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setKeyInsightslead}
                                    handleSelectBlock={handleKeyInsightsNavigation}
                                    items={items}
                                    setSelectBlock={setKeyInsightslead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'KeyInsights'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                            : seq.type === 'SwipeMiniGame' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>SwipeMiniGame</Text>
                                  <SwipeMiniGameCompo
                                    showReflectionQuestions={showReflectionQuestions}
                                    formData={formData}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'SwipeMiniGame'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setSwipeMiniGameNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setSwipeMiniGamelead}
                                    handleSelectBlock={handleSwipeMiniGameNavigation}
                                    items={items}
                                    setSelectBlock={setSwipeMiniGamelead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'SwipeMiniGame'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
			    : seq.type === 'PreAssessment' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>PreAssessment</Text>
                                  <PreAssessmentCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    formData={formData}
                                    targetSequence={targetSequence}
                                    gameId={id}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'PreAssessment'}
                                    setUploadedFiles={setUploadedFiles}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setPreAssessmentNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setPreAssessmentlead}
                                    handleSelectBlock={handlePreAssessmentNavigation}
                                    items={items}
                                    setSelectBlock={setPreAssessmentlead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'PreAssessment'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                            : seq.type === 'PostAssessment' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>PostAssessment</Text>
                                  <PostAssessmentCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    formData={formData}
                                    targetSequence={targetSequence}
                                    gameId={id}
                                    ShowReview={ShowReview}
                                    setUploadedFiles={setUploadedFiles}
                                    seq={seq}
                                    index={i}
                                    name={'PostAssessment'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setPostAssessmentNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setPostAssessmentlead}
                                    handleSelectBlock={handlePostAssessmentNavigation}
                                    items={items}
                                    setSelectBlock={setPostAssessmentlead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'PostAssessment'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                            : seq.type === 'Overview' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>Overview</Text>
                                  <OverviewCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                   formData={formData}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'Overview'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setOverviewNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setOverviewlead}
                                    handleSelectBlock={handleOverviewNavigation}
                                    items={items}
                                    setSelectBlock={setOverviewlead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'Overview'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                            : seq.type === 'WehaveChoose' ? (
                                      <ScaleFade initialScale={0.9} in={true}>
                                        <Card
                                          id={`tarSeqRef${seq.id}`}
                                          className="target-block"
                                          position={'relative'}
                                          boxShadow={
                                            seq.input === lastInputName
                                              ? '1px 2px 13px #a2a1b00a'
                                              : 'unset'
                                          }
                                          borderRadius={'20px'}
                                          transition={'0.1s linear'}
                                          borderWidth={{
                                            base:
                                              seq.id === targetSequence?.id &&
                                              '3px 3px 3px 3px',
                                            sm:
                                              seq.id === targetSequence?.id &&
                                              '3px 3px 3px 3px',
                                            lg:
                                              seq.id === targetSequence?.id &&
                                              '0 0 0 3px',
                                          }}
                                          borderStyle={{
                                            base:
                                              seq.id === targetSequence?.id &&
                                              'solid solid solid solid',
                                            sm:
                                              seq.id === targetSequence?.id &&
                                              'solid solid solid solid',
                                            lg:
                                              seq.id === targetSequence?.id &&
                                              'unset unset unset solid',
                                          }}
                                          borderColor={getNoteBorderColor(seq)}
                                          background={
                                            seq.input === lastInputName ||
                                              dragData.isDragging === true ||
                                              seq.id === targetSequence?.id
                                              ? null
                                              : 'unset'
                                          }
                                          _hover={{ background: '#f7f7f5' }}
                                          zIndex={
                                            seq.input === lastInputName ? '9' : 'unset'
                                          }
                                          tabIndex={0}
                                          onClick={(e) => handleKeyDown(e, i, seq)}
                                          onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                          height={
                                            seq.id === targetSequence?.id
                                              ? '100%'
                                              : '170px'
                                          }
                                        // overflowY={'hidden'}
                                        >
                                          <Text color={'gray.400'}>WehaveChoose</Text>
                                          <WehaveChooseCompo
                                            formData={formData}
                                            targetSequence={targetSequence}
                                            ShowReview={ShowReview}
                                            seq={seq}
                                            index={i}
                                            name={'Link'}
                                            getSeq={getSeq}
                                            duplicateSeq={duplicateSeq}
                                            delSeq={delSeq}
                                            alphabet={alphabet}
                                            input={input}
                                            setNavigation={setWehaveChooseNavigation}
                                            showSelectBlock={showSelectBlock}
                                            handleBlock={setWehaveChooselead}
                                            handleSelectBlock={handleWehaveChooseNavigation}
                                            items={items}
                                            setSelectBlock={setWehaveChooselead}
                                            handleInput={(e: any) =>
                                              handleInput(e, i, seq.input)
                                            }
                                            handleNDI={handleNDI}
                                            validation={validation}
                                            currentseq={count}
                                            blockOnFocusHanlder={blockOnFocusHanlder}
                                            blockOnBlurHanlder={blockOnBlurHanlder}
                                          />

                                          {ShowReview ? (
                                            <Accordion allowToggle>
                                              <AccordionItem>
                                                <h2>
                                                  <AccordionButton>
                                                    <Box
                                                      as="span"
                                                      // flex="1"
                                                      w={'100%'}
                                                      display={'flex'}
                                                      justifyContent={'space-between'}
                                                      textAlign="left"
                                                      fontSize={'0.875rem'}
                                                      color={textColor}
                                                    >
                                                      <Text>See All Reviews</Text>
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        <Text mr={'5px'}>
                                                          <Icon
                                                            as={IoCheckmarkDoneCircle}
                                                            color={'green.300'}
                                                          />{' '}
                                                          Read:{' '}
                                                          <span
                                                            style={{
                                                              fontWeight: 'bold',
                                                            }}
                                                          >
                                                            {blockWiseReviewCount[
                                                              seq.input
                                                            ]?.readCount ?? '0'}
                                                          </span>
                                                        </Text>
                                                        <Text>
                                                          <Icon
                                                            as={MdPendingActions}
                                                            color={'blue.300'}
                                                          />
                                                          Unread:{' '}
                                                          <span
                                                            style={{
                                                              fontWeight: 'bold',
                                                            }}
                                                          >
                                                            {blockWiseReviewCount[
                                                              seq.input
                                                            ]?.unReadCount ?? '0'}
                                                          </span>
                                                        </Text>
                                                      </Box>
                                                    </Box>
                                                    <AccordionIcon />
                                                  </AccordionButton>
                                                </h2>
                                                {seq.id === targetSequence?.id && (
                                                  <AccordionPanel pb={4}>
                                                    {reviews &&
                                                      reviews
                                                        ?.filter(
                                                          (item: any) =>
                                                            item?.blockSecondaryId ===
                                                            seq.input &&
                                                            item?.blockQuestNo ===
                                                            seq.questNo,
                                                        )
                                                        .map((value: any, ind: any) => {
                                                          const reviewer =
                                                            reviewers &&
                                                            reviewers.find(
                                                              (rev: any) =>
                                                                rev?.gameReviewerId ===
                                                                value?.gameReviewerId,
                                                            );
                                                          return (
                                                            <Box
                                                              key={ind}
                                                              bg={
                                                                value?.readStatus === 0
                                                                  ? '#e3f7fd'
                                                                  : ''
                                                              }
                                                              borderRadius={'10px'}
                                                              onMouseEnter={() =>
                                                                value?.readStatus === 0
                                                                  ? handleMouseEnter(
                                                                    value,
                                                                    ind,
                                                                  )
                                                                  : null
                                                              }
                                                            >
                                                              <Box
                                                                display={'flex'}
                                                                alignItems={'center'}
                                                              >
                                                                {value?.readStatus ===
                                                                  0 ? (
                                                                  <Badge
                                                                    mr={'5px'}
                                                                    borderRadius={
                                                                      'none'
                                                                    }
                                                                    width={'auto'}
                                                                    h={'fit-content'}
                                                                    variant="outline"
                                                                    colorScheme="green"
                                                                  >
                                                                    New
                                                                  </Badge>
                                                                ) : (
                                                                  ''
                                                                )}
                                                              </Box>
                                                              <Box
                                                                w={'100%'}
                                                                display={'flex'}
                                                                justifyContent={
                                                                  'space-between'
                                                                }
                                                              >
                                                                <Box
                                                                  w={'100%'}
                                                                  display={'flex'}
                                                                  alignItems={'center'}
                                                                >
                                                                  <Img
                                                                    src={pro}
                                                                    w={'40px'}
                                                                    h={'40px'}
                                                                    alt="pro"
                                                                    borderRadius={'50%'}
                                                                  />
                                                                  <Text ml={'15px'}>
                                                                    {reviewer?.emailId ===
                                                                      null
                                                                      ? reviewer
                                                                        ?.ReviewingCreator
                                                                        ?.ctMail
                                                                      : reviewer?.emailId}
                                                                  </Text>
                                                                </Box>
                                                                <Box
                                                                  whiteSpace={'nowrap'}
                                                                >
                                                                  <Text fontSize={'14'}>
                                                                    Posted On :
                                                                    {value?.updatedAt
                                                                      ? new Date(
                                                                        value.updatedAt,
                                                                      ).toLocaleDateString()
                                                                      : ''}
                                                                  </Text>
                                                                </Box>
                                                              </Box>
                                                              <Box
                                                                mb={'10px'}
                                                                mt={'10px'}
                                                              >
                                                                {value?.review}
                                                              </Box>
                                                            </Box>
                                                          );
                                                        })}
                                                    {(!reviews ||
                                                      reviews.length === 0 ||
                                                      reviews.filter(
                                                        (item: any) =>
                                                          item?.blockSecondaryId ===
                                                          seq.input &&
                                                          item?.blockQuestNo ===
                                                          seq.questNo,
                                                      ).length === 0) && (
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                          justifyContent={'center'}
                                                        >
                                                          <Text>
                                                            No Reviews For This Block
                                                          </Text>
                                                        </Box>
                                                      )}
                                                  </AccordionPanel>
                                                )}
                                              </AccordionItem>
                                            </Accordion>
                                          ) : (
                                            ''
                                          )}

                                          {seq.id == showMiniBox ? (
                                            <MiniBox seq={seq} i={i} name={'WehaveChoose'} />
                                          ) : null}
                                        </Card>
                                      </ScaleFade>
                                    )
                            : seq.type === 'ScenarioCompletion' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>ScenarioCompletion</Text>
                                  <ScenarioCompletionCompo
                                 
                                  BlockItems={BlockItems}
                                  formData={formData}
                                    listBlockItems={listBlockItems}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    GameId={GameId}
                                    name={'ScenarioCompletion'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setScenarioCompletionNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setScenarioCompletionlead}
                                    handleSelectBlock={handleScenarioCompletionNavigation}
                                    items={items}
                                    setSelectBlock={setScenarioCompletionlead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'ScenarioCompletion'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                             : seq.type === 'DragForNow' ? (
                                        <ScaleFade initialScale={0.9} in={true}>
                                          <Card
                                            id={`tarSeqRef${seq.id}`}
                                            className="target-block"
                                            position={'relative'}
                                            boxShadow={
                                              seq.input === lastInputName
                                                ? '1px 2px 13px #a2a1b00a'
                                                : 'unset'
                                            }
                                            borderRadius={'20px'}
                                            transition={'0.1s linear'}
                                            borderWidth={{
                                              base:
                                                seq.id === targetSequence?.id &&
                                                '3px 3px 3px 3px',
                                              sm:
                                                seq.id === targetSequence?.id &&
                                                '3px 3px 3px 3px',
                                              lg:
                                                seq.id === targetSequence?.id &&
                                                '0 0 0 3px',
                                            }}
                                            borderStyle={{
                                              base:
                                                seq.id === targetSequence?.id &&
                                                'solid solid solid solid',
                                              sm:
                                                seq.id === targetSequence?.id &&
                                                'solid solid solid solid',
                                              lg:
                                                seq.id === targetSequence?.id &&
                                                'unset unset unset solid',
                                            }}
                                            borderColor={getNoteBorderColor(seq)}
                                            background={
                                              seq.input === lastInputName ||
                                                dragData.isDragging === true ||
                                                seq.id === targetSequence?.id
                                                ? null
                                                : 'unset'
                                            }
                                            _hover={{ background: '#f7f7f5' }}
                                            zIndex={
                                              seq.input === lastInputName ? '9' : 'unset'
                                            }
                                            tabIndex={0}
                                            onClick={(e) => handleKeyDown(e, i, seq)}
                                            onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                            height={
                                              seq.id === targetSequence?.id
                                                ? '100%'
                                                : '170px'
                                            }
                                          // overflowY={'hidden'}
                                          >
                                            <Text color={'gray.400'}>DragForNow</Text>
                                            <DragForNowCompo
                                              formData={formData}
                                              targetSequence={targetSequence}
                                              ShowReview={ShowReview}
                                              seq={seq}
                                              index={i}
                                              name={'DragForNow'}
                                              getSeq={getSeq}
                                              duplicateSeq={duplicateSeq}
                                              delSeq={delSeq}
                                              alphabet={alphabet}
                                              input={input}
                                              setNavigation={setDragForNowNavigation}
                                              showSelectBlock={showSelectBlock}
                                              handleBlock={setDragForNowlead}
                                              handleSelectBlock={handleDragForNowNavigation}
                                              items={items}
                                              setSelectBlock={setDragForNowlead}
                                              handleInput={(e: any) =>
                                                handleInput(e, i, seq.input)
                                              }
                                              handleNDI={handleNDI}
                                              validation={validation}
                                              currentseq={count}
                                              blockOnFocusHanlder={blockOnFocusHanlder}
                                              blockOnBlurHanlder={blockOnBlurHanlder}
                                            />

                                            {ShowReview ? (
                                              <Accordion allowToggle>
                                                <AccordionItem>
                                                  <h2>
                                                    <AccordionButton>
                                                      <Box
                                                        as="span"
                                                        // flex="1"
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={'space-between'}
                                                        textAlign="left"
                                                        fontSize={'0.875rem'}
                                                        color={textColor}
                                                      >
                                                        <Text>See All Reviews</Text>
                                                        <Box
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Text mr={'5px'}>
                                                            <Icon
                                                              as={IoCheckmarkDoneCircle}
                                                              color={'green.300'}
                                                            />{' '}
                                                            Read:{' '}
                                                            <span
                                                              style={{
                                                                fontWeight: 'bold',
                                                              }}
                                                            >
                                                              {blockWiseReviewCount[
                                                                seq.input
                                                              ]?.readCount ?? '0'}
                                                            </span>
                                                          </Text>
                                                          <Text>
                                                            <Icon
                                                              as={MdPendingActions}
                                                              color={'blue.300'}
                                                            />
                                                            Unread:{' '}
                                                            <span
                                                              style={{
                                                                fontWeight: 'bold',
                                                              }}
                                                            >
                                                              {blockWiseReviewCount[
                                                                seq.input
                                                              ]?.unReadCount ?? '0'}
                                                            </span>
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <AccordionIcon />
                                                    </AccordionButton>
                                                  </h2>
                                                  {seq.id === targetSequence?.id && (
                                                    <AccordionPanel pb={4}>
                                                      {reviews &&
                                                        reviews
                                                          ?.filter(
                                                            (item: any) =>
                                                              item?.blockSecondaryId ===
                                                              seq.input &&
                                                              item?.blockQuestNo ===
                                                              seq.questNo,
                                                          )
                                                          .map((value: any, ind: any) => {
                                                            const reviewer =
                                                              reviewers &&
                                                              reviewers.find(
                                                                (rev: any) =>
                                                                  rev?.gameReviewerId ===
                                                                  value?.gameReviewerId,
                                                              );
                                                            return (
                                                              <Box
                                                                key={ind}
                                                                bg={
                                                                  value?.readStatus === 0
                                                                    ? '#e3f7fd'
                                                                    : ''
                                                                }
                                                                borderRadius={'10px'}
                                                                onMouseEnter={() =>
                                                                  value?.readStatus === 0
                                                                    ? handleMouseEnter(
                                                                      value,
                                                                      ind,
                                                                    )
                                                                    : null
                                                                }
                                                              >
                                                                <Box
                                                                  display={'flex'}
                                                                  alignItems={'center'}
                                                                >
                                                                  {value?.readStatus ===
                                                                    0 ? (
                                                                    <Badge
                                                                      mr={'5px'}
                                                                      borderRadius={
                                                                        'none'
                                                                      }
                                                                      width={'auto'}
                                                                      h={'fit-content'}
                                                                      variant="outline"
                                                                      colorScheme="green"
                                                                    >
                                                                      New
                                                                    </Badge>
                                                                  ) : (
                                                                    ''
                                                                  )}
                                                                </Box>
                                                                <Box
                                                                  w={'100%'}
                                                                  display={'flex'}
                                                                  justifyContent={
                                                                    'space-between'
                                                                  }
                                                                >
                                                                  <Box
                                                                    w={'100%'}
                                                                    display={'flex'}
                                                                    alignItems={'center'}
                                                                  >
                                                                    <Img
                                                                      src={pro}
                                                                      w={'40px'}
                                                                      h={'40px'}
                                                                      alt="pro"
                                                                      borderRadius={'50%'}
                                                                    />
                                                                    <Text ml={'15px'}>
                                                                      {reviewer?.emailId ===
                                                                        null
                                                                        ? reviewer
                                                                          ?.ReviewingCreator
                                                                          ?.ctMail
                                                                        : reviewer?.emailId}
                                                                    </Text>
                                                                  </Box>
                                                                  <Box
                                                                    whiteSpace={'nowrap'}
                                                                  >
                                                                    <Text fontSize={'14'}>
                                                                      Posted On :
                                                                      {value?.updatedAt
                                                                        ? new Date(
                                                                          value.updatedAt,
                                                                        ).toLocaleDateString()
                                                                        : ''}
                                                                    </Text>
                                                                  </Box>
                                                                </Box>
                                                                <Box
                                                                  mb={'10px'}
                                                                  mt={'10px'}
                                                                >
                                                                  {value?.review}
                                                                </Box>
                                                              </Box>
                                                            );
                                                          })}
                                                      {(!reviews ||
                                                        reviews.length === 0 ||
                                                        reviews.filter(
                                                          (item: any) =>
                                                            item?.blockSecondaryId ===
                                                            seq.input &&
                                                            item?.blockQuestNo ===
                                                            seq.questNo,
                                                        ).length === 0) && (
                                                          <Box
                                                            w={'100%'}
                                                            display={'flex'}
                                                            alignItems={'center'}
                                                            justifyContent={'center'}
                                                          >
                                                            <Text>
                                                              No Reviews For This Block
                                                            </Text>
                                                          </Box>
                                                        )}
                                                    </AccordionPanel>
                                                  )}
                                                </AccordionItem>
                                              </Accordion>
                                            ) : (
                                              ''
                                            )}

                                            {seq.id == showMiniBox ? (
                                              <MiniBox seq={seq} i={i} name={'SwipeMiniGame'} />
                                            ) : null}
                                          </Card>
                                        </ScaleFade>
                                      )
                           
                            : seq.type === 'Reflection' ? (
                              <ScaleFade initialScale={0.9} in={true}>
                                <Card
                                  id={`tarSeqRef${seq.id}`}
                                  className="target-block"
                                  position={'relative'}
                                  boxShadow={
                                    seq.input === lastInputName
                                      ? '1px 2px 13px #a2a1b00a'
                                      : 'unset'
                                  }
                                  borderRadius={'20px'}
                                  transition={'0.1s linear'}
                                  borderWidth={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      '3px 3px 3px 3px',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      '0 0 0 3px',
                                  }}
                                  borderStyle={{
                                    base:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    sm:
                                      seq.id === targetSequence?.id &&
                                      'solid solid solid solid',
                                    lg:
                                      seq.id === targetSequence?.id &&
                                      'unset unset unset solid',
                                  }}
                                  borderColor={getNoteBorderColor(seq)}
                                  background={
                                    seq.input === lastInputName ||
                                    dragData.isDragging === true ||
                                    seq.id === targetSequence?.id
                                      ? null
                                      : 'unset'
                                  }
                                  _hover={{ background: '#f7f7f5' }}
                                  zIndex={
                                    seq.input === lastInputName ? '9' : 'unset'
                                  }
                                  tabIndex={0}
                                  onClick={(e) => handleKeyDown(e, i, seq)}
                                  onKeyDown={(e) => handleKeyDown(e, i, seq)}
                                  height={
                                    seq.id === targetSequence?.id
                                      ? '100%'
                                      : '170px'
                                  }
                                  // overflowY={'hidden'}
                                >
                                  <Text color={'gray.400'}>Reflection</Text>
                                  <ReflectionCompo
                                  showReflectionQuestions={showReflectionQuestions}
                                    formData={formData}
                                    targetSequence={targetSequence}
                                    ShowReview={ShowReview}
                                    seq={seq}
                                    index={i}
                                    name={'Reflection'}
                                    getSeq={getSeq}
                                    duplicateSeq={duplicateSeq}
                                    delSeq={delSeq}
                                    alphabet={alphabet}
                                    input={input}
                                    setNavigation={setReflectionNavigation}
                                    showSelectBlock={showSelectBlock}
                                    handleBlock={setReflectionlead}
                                    handleSelectBlock={handleReflectionNavigation}
                                    items={items}
                                    setSelectBlock={setReflectionlead}
                                    handleInput={(e: any) =>
                                      handleInput(e, i, seq.input)
                                    }
                                    handleNDI={handleNDI}
                                    validation={validation}
                                    currentseq={count}
                                    blockOnFocusHanlder={blockOnFocusHanlder}
                                    blockOnBlurHanlder={blockOnBlurHanlder}
                                  />

                                  {ShowReview ? (
                                    <Accordion allowToggle>
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              // flex="1"
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              textAlign="left"
                                              fontSize={'0.875rem'}
                                              color={textColor}
                                            >
                                              <Text>See All Reviews</Text>
                                              <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Text mr={'5px'}>
                                                  <Icon
                                                    as={IoCheckmarkDoneCircle}
                                                    color={'green.300'}
                                                  />{' '}
                                                  Read:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.readCount ?? '0'}
                                                  </span>
                                                </Text>
                                                <Text>
                                                  <Icon
                                                    as={MdPendingActions}
                                                    color={'blue.300'}
                                                  />
                                                  Unread:{' '}
                                                  <span
                                                    style={{
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {blockWiseReviewCount[
                                                      seq.input
                                                    ]?.unReadCount ?? '0'}
                                                  </span>
                                                </Text>
                                              </Box>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        {seq.id === targetSequence?.id && (
                                          <AccordionPanel pb={4}>
                                            {reviews &&
                                              reviews
                                                ?.filter(
                                                  (item: any) =>
                                                    item?.blockSecondaryId ===
                                                      seq.input &&
                                                    item?.blockQuestNo ===
                                                      seq.questNo,
                                                )
                                                .map((value: any, ind: any) => {
                                                  const reviewer =
                                                    reviewers &&
                                                    reviewers.find(
                                                      (rev: any) =>
                                                        rev?.gameReviewerId ===
                                                        value?.gameReviewerId,
                                                    );
                                                  return (
                                                    <Box
                                                      key={ind}
                                                      bg={
                                                        value?.readStatus === 0
                                                          ? '#e3f7fd'
                                                          : ''
                                                      }
                                                      borderRadius={'10px'}
                                                      onMouseEnter={() =>
                                                        value?.readStatus === 0
                                                          ? handleMouseEnter(
                                                              value,
                                                              ind,
                                                            )
                                                          : null
                                                      }
                                                    >
                                                      <Box
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                      >
                                                        {value?.readStatus ===
                                                        0 ? (
                                                          <Badge
                                                            mr={'5px'}
                                                            borderRadius={
                                                              'none'
                                                            }
                                                            width={'auto'}
                                                            h={'fit-content'}
                                                            variant="outline"
                                                            colorScheme="green"
                                                          >
                                                            New
                                                          </Badge>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Box>
                                                      <Box
                                                        w={'100%'}
                                                        display={'flex'}
                                                        justifyContent={
                                                          'space-between'
                                                        }
                                                      >
                                                        <Box
                                                          w={'100%'}
                                                          display={'flex'}
                                                          alignItems={'center'}
                                                        >
                                                          <Img
                                                            src={pro}
                                                            w={'40px'}
                                                            h={'40px'}
                                                            alt="pro"
                                                            borderRadius={'50%'}
                                                          />
                                                          <Text ml={'15px'}>
                                                            {reviewer?.emailId ===
                                                            null
                                                              ? reviewer
                                                                  ?.ReviewingCreator
                                                                  ?.ctMail
                                                              : reviewer?.emailId}
                                                          </Text>
                                                        </Box>
                                                        <Box
                                                          whiteSpace={'nowrap'}
                                                        >
                                                          <Text fontSize={'14'}>
                                                            Posted On :
                                                            {value?.updatedAt
                                                              ? new Date(
                                                                  value.updatedAt,
                                                                ).toLocaleDateString()
                                                              : ''}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                      <Box
                                                        mb={'10px'}
                                                        mt={'10px'}
                                                      >
                                                        {value?.review}
                                                      </Box>
                                                    </Box>
                                                  );
                                                })}
                                            {(!reviews ||
                                              reviews.length === 0 ||
                                              reviews.filter(
                                                (item: any) =>
                                                  item?.blockSecondaryId ===
                                                    seq.input &&
                                                  item?.blockQuestNo ===
                                                    seq.questNo,
                                              ).length === 0) && (
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                              >
                                                <Text>
                                                  No Reviews For This Block
                                                </Text>
                                              </Box>
                                            )}
                                          </AccordionPanel>
                                        )}
                                      </AccordionItem>
                                    </Accordion>
                                  ) : (
                                    ''
                                  )}

                                  {seq.id == showMiniBox ? (
                                    <MiniBox seq={seq} i={i} name={'Reflection'} />
                                  ) : null}
                                </Card>
                              </ScaleFade>
                            )
                            
                            : null}
                          </Box>
                        </div>
                      );
                    }}
                  </Draggable>
                );
              })}
          </CustomAccordion>
        </Box>

        <Box
          className="bottom-block"
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Tooltip hasArrow label="Add Note">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('Note')}
            >
              <Icon as={MdOutlineStickyNote2} fontSize={'23px'} />
            </Box>
          </Tooltip>
          <Tooltip hasArrow label="Add Dialog">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('Dialog')}
            >
              <Icon as={TbMessages} fontSize={'23px'} />
            </Box>
          </Tooltip>
          <Tooltip hasArrow label="Add Interaction">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('Interaction')}
            >
              <Icon as={TbHandClick} fontSize={'23px'} />
            </Box>
          </Tooltip>
          {/* icon */}
          <Tooltip hasArrow label="Add Link">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('Link')}
            >
              <Icon as={HiLink} fontSize={'23px'} />
            </Box>
          </Tooltip>
          {/* ref */}
           {showReflectionQuestions && (
            <>
          <Tooltip hasArrow label="Reflection">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('Reflection')}
            >
              <Icon as={MdPsychology } fontSize={'23px'} />
            </Box>
          </Tooltip>
          <Tooltip hasArrow label="Overview">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('Overview')}
            >
              <Icon as={FaClipboardList} fontSize={'23px'} />
            </Box>
          </Tooltip>
         
          <Tooltip hasArrow label="KeyInsights">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('KeyInsights')}
            >
              <Icon as={FaChartLine} fontSize={'23px'} />
            </Box>
          </Tooltip>
         
          <Tooltip hasArrow label="PreAssessment">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('PreAssessment')}
            >
              <Icon as={MdOutlineAssessment} fontSize={'23px'} />
            </Box>
          </Tooltip>
          <Tooltip hasArrow label="PostAssessment">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('PostAssessment')}
            >
              <Icon as={MdAssessment} fontSize={'23px'} />
            </Box>
          </Tooltip>
              <Tooltip hasArrow label="We Have Choose">
                <Box
                  mr={'20px'}
                  p={'20px'}
                  h={'60px'}
                  w={'60px'}
                  color={'#3311db'}
                  display={'grid'}
                  placeItems={'center'}
                  borderRadius={'100px'}
                  boxShadow={'1px 3px 10px #6565641f'}
                  cursor={'pointer'}
                  filter={'drop-shadow(4px 5px 8px #8080807d)'}
                  _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
                  onClick={() => handleBottomNDI('WehaveChoose')}
                >
                  <Icon as={FaPuzzlePiece} fontSize={'23px'} />
                </Box>
              </Tooltip>
               <Tooltip hasArrow label="SwipeMiniGame">
            <Box
              mr={'20px'}
              p={'20px'}
              h={'60px'}
              w={'60px'}
              color={'#3311db'}
              display={'grid'}
              placeItems={'center'}
              borderRadius={'100px'}
              boxShadow={'1px 3px 10px #6565641f'}
              cursor={'pointer'}
              filter={'drop-shadow(4px 5px 8px #8080807d)'}
              _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
              onClick={() => handleBottomNDI('SwipeMiniGame')}
            >
              <Icon as={MdOutlineSwipe} fontSize={'23px'} />
            </Box>
          </Tooltip>
              <Tooltip hasArrow label="Drag For Now">
                <Box
                  mr={'20px'}
                  p={'20px'}
                  h={'60px'}
                  w={'60px'}
                  color={'#3311db'}
                  display={'grid'}
                  placeItems={'center'}
                  borderRadius={'100px'}
                  boxShadow={'1px 3px 10px #6565641f'}
                  cursor={'pointer'}
                  filter={'drop-shadow(4px 5px 8px #8080807d)'}
                  _hover={{ boxShadow: '#7090b01a 0px 18px 22px inset' }}
                  onClick={() => handleBottomNDI('DragForNow')}
                >
                  <Icon as={TbDragDrop2 } fontSize={'23px'} />
                </Box>
              </Tooltip>
          </>
           )}
        </Box>
      </Box>
      <ChatButton setChatNote={setChatNote} chatNote={chatNote} />
    </>
  );
};

export default NDIMain;




















